// @ts-nocheck
type Theme = {
  accentBackground: string;
  accentColor: string;
  background0: string;
  background025: string;
  background05: string;
  background075: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
  color6: string;
  color7: string;
  color8: string;
  color9: string;
  color10: string;
  color11: string;
  color12: string;
  color0: string;
  color025: string;
  color05: string;
  color075: string;
  background: string;
  backgroundHover: string;
  backgroundPress: string;
  backgroundFocus: string;
  borderColor: string;
  borderColorHover: string;
  borderColorPress: string;
  borderColorFocus: string;
  color: string;
  colorHover: string;
  colorPress: string;
  colorFocus: string;
  colorTransparent: string;
  placeholderColor: string;
  outlineColor: string;
  blue1: string;
  blue2: string;
  blue3: string;
  blue4: string;
  blue5: string;
  blue6: string;
  blue7: string;
  blue8: string;
  blue9: string;
  blue10: string;
  blue11: string;
  blue12: string;
  gray1: string;
  gray2: string;
  gray3: string;
  gray4: string;
  gray5: string;
  gray6: string;
  gray7: string;
  gray8: string;
  gray9: string;
  gray10: string;
  gray11: string;
  gray12: string;
  green1: string;
  green2: string;
  green3: string;
  green4: string;
  green5: string;
  green6: string;
  green7: string;
  green8: string;
  green9: string;
  green10: string;
  green11: string;
  green12: string;
  orange1: string;
  orange2: string;
  orange3: string;
  orange4: string;
  orange5: string;
  orange6: string;
  orange7: string;
  orange8: string;
  orange9: string;
  orange10: string;
  orange11: string;
  orange12: string;
  orangeA1: string;
  orangeA2: string;
  orangeA3: string;
  orangeA4: string;
  orangeA5: string;
  orangeA6: string;
  orangeA7: string;
  orangeA8: string;
  orangeA9: string;
  orangeA10: string;
  orangeA11: string;
  orangeA12: string;
  pink1: string;
  pink2: string;
  pink3: string;
  pink4: string;
  pink5: string;
  pink6: string;
  pink7: string;
  pink8: string;
  pink9: string;
  pink10: string;
  pink11: string;
  pink12: string;
  purple1: string;
  purple2: string;
  purple3: string;
  purple4: string;
  purple5: string;
  purple6: string;
  purple7: string;
  purple8: string;
  purple9: string;
  purple10: string;
  purple11: string;
  purple12: string;
  red1: string;
  red2: string;
  red3: string;
  red4: string;
  red5: string;
  red6: string;
  red7: string;
  red8: string;
  red9: string;
  red10: string;
  red11: string;
  red12: string;
  yellow1: string;
  yellow2: string;
  yellow3: string;
  yellow4: string;
  yellow5: string;
  yellow6: string;
  yellow7: string;
  yellow8: string;
  yellow9: string;
  yellow10: string;
  yellow11: string;
  yellow12: string;
  bronze1: string;
  bronze2: string;
  bronze3: string;
  bronze4: string;
  bronze5: string;
  bronze6: string;
  bronze7: string;
  bronze8: string;
  bronze9: string;
  bronze10: string;
  bronze11: string;
  bronze12: string;
  gold1: string;
  gold2: string;
  gold3: string;
  gold4: string;
  gold5: string;
  gold6: string;
  gold7: string;
  gold8: string;
  gold9: string;
  gold10: string;
  gold11: string;
  gold12: string;
  shadowColor: string;
  shadowColorHover: string;
  shadowColorPress: string;
  shadowColorFocus: string;

}

function t(a: [number, number][]) {
  let res: Record<string,string> = {}
  for (const [ki, vi] of a) {
    res[ks[ki] as string] = colors[vi] as string
  }
  return res as Theme
}
export const colors = [
  'hsl(210, 98.8%, 94.0%)',
  'hsl(214, 65.8%, 17.9%)',
  'rgba(255,255,255,0)',
  'rgba(255,255,255,0.25)',
  'rgba(255,255,255,0.5)',
  'rgba(255,255,255,0.75)',
  '#fff',
  '#f8f8f8',
  'hsl(0, 0%, 96.3%)',
  'hsl(0, 0%, 94.1%)',
  'hsl(0, 0%, 92.0%)',
  'hsl(0, 0%, 90.0%)',
  'hsl(0, 0%, 88.5%)',
  'hsl(0, 0%, 81.0%)',
  'hsl(0, 0%, 56.1%)',
  'hsl(0, 0%, 50.3%)',
  'hsl(0, 0%, 42.5%)',
  'hsl(0, 0%, 9.0%)',
  'rgba(10,10,10,0)',
  'rgba(10,10,10,0.25)',
  'rgba(10,10,10,0.5)',
  'rgba(10,10,10,0.75)',
  'hsl(206, 100%, 99.2%)',
  'hsl(210, 100%, 98.0%)',
  'hsl(209, 100%, 96.5%)',
  'hsl(209, 95.0%, 90.1%)',
  'hsl(209, 81.2%, 84.5%)',
  'hsl(208, 77.5%, 76.9%)',
  'hsl(206, 81.9%, 65.3%)',
  'hsl(206, 100%, 50.0%)',
  'hsl(208, 100%, 47.3%)',
  'hsl(211, 100%, 43.2%)',
  'hsl(211, 100%, 15.0%)',
  'hsl(0, 0%, 99.0%)',
  'hsl(0, 0%, 97.3%)',
  'hsl(0, 0%, 95.1%)',
  'hsl(0, 0%, 93.0%)',
  'hsl(0, 0%, 90.9%)',
  'hsl(0, 0%, 88.7%)',
  'hsl(0, 0%, 85.8%)',
  'hsl(0, 0%, 78.0%)',
  'hsl(0, 0%, 52.3%)',
  'hsl(0, 0%, 43.5%)',
  'hsl(136, 50.0%, 98.9%)',
  'hsl(138, 62.5%, 96.9%)',
  'hsl(139, 55.2%, 94.5%)',
  'hsl(140, 48.7%, 91.0%)',
  'hsl(141, 43.7%, 86.0%)',
  'hsl(143, 40.3%, 79.0%)',
  'hsl(146, 38.5%, 69.0%)',
  'hsl(151, 40.2%, 54.1%)',
  'hsl(151, 55.0%, 41.5%)',
  'hsl(152, 57.5%, 37.6%)',
  'hsl(153, 67.0%, 28.5%)',
  'hsl(155, 40.0%, 14.0%)',
  'hsl(24, 70.0%, 99.0%)',
  'hsl(24, 83.3%, 97.6%)',
  'hsl(24, 100%, 95.3%)',
  'hsl(25, 100%, 92.2%)',
  'hsl(25, 100%, 88.2%)',
  'hsl(25, 100%, 82.8%)',
  'hsl(24, 100%, 75.3%)',
  'hsl(24, 94.5%, 64.3%)',
  'hsl(24, 94.0%, 50.0%)',
  'hsl(24, 100%, 46.5%)',
  'hsl(24, 100%, 37.0%)',
  'hsl(15, 60.0%, 17.0%)',
  'hsla(20, 94.9%, 38.7%, 0.016)',
  'hsla(24, 95.8%, 46.5%, 0.044)',
  'hsla(25, 100%, 50.5%, 0.095)',
  'hsla(26, 100%, 50.0%, 0.157)',
  'hsla(25, 100%, 50.1%, 0.236)',
  'hsla(25, 100%, 50.1%, 0.346)',
  'hsla(24, 100%, 50.1%, 0.495)',
  'hsla(24, 99.7%, 48.7%, 0.695)',
  'hsla(24, 99.9%, 48.4%, 0.969)',
  'hsla(23, 100%, 46.4%, 0.980)',
  'hsla(23, 100%, 36.8%, 0.980)',
  'hsla(15, 99.4%, 11.0%, 0.934)',
  'hsl(322, 100%, 99.4%)',
  'hsl(323, 100%, 98.4%)',
  'hsl(323, 86.3%, 96.5%)',
  'hsl(323, 78.7%, 94.2%)',
  'hsl(323, 72.2%, 91.1%)',
  'hsl(323, 66.3%, 86.6%)',
  'hsl(323, 62.0%, 80.1%)',
  'hsl(323, 60.3%, 72.4%)',
  'hsl(322, 65.0%, 54.5%)',
  'hsl(322, 63.9%, 50.7%)',
  'hsl(322, 75.0%, 46.0%)',
  'hsl(320, 70.0%, 13.5%)',
  'hsl(280, 65.0%, 99.4%)',
  'hsl(276, 100%, 99.0%)',
  'hsl(276, 83.1%, 97.0%)',
  'hsl(275, 76.4%, 94.7%)',
  'hsl(275, 70.8%, 91.8%)',
  'hsl(274, 65.4%, 87.8%)',
  'hsl(273, 61.0%, 81.7%)',
  'hsl(272, 60.0%, 73.5%)',
  'hsl(272, 51.0%, 54.0%)',
  'hsl(272, 46.8%, 50.3%)',
  'hsl(272, 50.0%, 45.8%)',
  'hsl(272, 66.0%, 16.0%)',
  'hsl(359, 100%, 99.4%)',
  'hsl(359, 100%, 98.6%)',
  'hsl(360, 100%, 96.8%)',
  'hsl(360, 97.9%, 94.8%)',
  'hsl(360, 90.2%, 91.9%)',
  'hsl(360, 81.7%, 87.8%)',
  'hsl(359, 74.2%, 81.7%)',
  'hsl(359, 69.5%, 74.3%)',
  'hsl(358, 75.0%, 59.0%)',
  'hsl(358, 69.4%, 55.2%)',
  'hsl(358, 65.0%, 48.7%)',
  'hsl(354, 50.0%, 14.6%)',
  'hsl(60, 54.0%, 98.5%)',
  'hsl(52, 100%, 95.5%)',
  'hsl(55, 100%, 90.9%)',
  'hsl(54, 100%, 86.6%)',
  'hsl(52, 97.9%, 82.0%)',
  'hsl(50, 89.4%, 76.1%)',
  'hsl(47, 80.4%, 68.0%)',
  'hsl(48, 100%, 46.1%)',
  'hsl(53, 92.0%, 50.0%)',
  'hsl(50, 100%, 48.5%)',
  'hsl(42, 100%, 29.0%)',
  'hsl(40, 55.0%, 13.5%)',
  'hsl(15, 30.0%, 99.1%)',
  'hsl(17, 63.6%, 97.8%)',
  'hsl(17, 42.1%, 95.2%)',
  'hsl(17, 35.2%, 92.1%)',
  'hsl(17, 31.5%, 88.2%)',
  'hsl(17, 29.0%, 83.0%)',
  'hsl(17, 26.9%, 75.6%)',
  'hsl(17, 25.1%, 66.5%)',
  'hsl(17, 20.0%, 54.0%)',
  'hsl(17, 18.1%, 50.1%)',
  'hsl(15, 20.0%, 43.1%)',
  'hsl(12, 22.0%, 21.5%)',
  'hsl(50, 20.0%, 99.1%)',
  'hsl(47, 52.9%, 96.7%)',
  'hsl(46, 38.2%, 93.7%)',
  'hsl(44, 32.7%, 90.1%)',
  'hsl(43, 29.9%, 85.7%)',
  'hsl(41, 28.3%, 79.8%)',
  'hsl(39, 27.6%, 71.9%)',
  'hsl(36, 27.2%, 61.8%)',
  'hsl(36, 20.0%, 49.5%)',
  'hsl(36, 19.8%, 45.7%)',
  'hsl(36, 20.0%, 39.0%)',
  'hsl(36, 16.0%, 20.0%)',
  'rgba(0,0,0,0.085)',
  'rgba(0,0,0,0.04)',
  '#050505',
  '#151515',
  '#191919',
  '#232323',
  '#282828',
  '#323232',
  '#424242',
  '#494949',
  '#545454',
  '#626262',
  '#a5a5a5',
  'hsl(212, 35.0%, 9.2%)',
  'hsl(216, 50.0%, 11.8%)',
  'hsl(214, 59.4%, 15.3%)',
  'hsl(213, 71.2%, 20.2%)',
  'hsl(212, 77.4%, 23.1%)',
  'hsl(211, 85.1%, 27.4%)',
  'hsl(211, 89.7%, 34.1%)',
  'hsl(209, 100%, 60.6%)',
  'hsl(210, 100%, 66.1%)',
  'hsl(206, 98.0%, 95.8%)',
  'hsl(0, 0%, 8.5%)',
  'hsl(0, 0%, 11.0%)',
  'hsl(0, 0%, 13.6%)',
  'hsl(0, 0%, 15.8%)',
  'hsl(0, 0%, 17.9%)',
  'hsl(0, 0%, 20.5%)',
  'hsl(0, 0%, 24.3%)',
  'hsl(0, 0%, 31.2%)',
  'hsl(0, 0%, 43.9%)',
  'hsl(0, 0%, 49.4%)',
  'hsl(0, 0%, 62.8%)',
  'hsl(146, 30.0%, 7.4%)',
  'hsl(155, 44.2%, 8.4%)',
  'hsl(155, 46.7%, 10.9%)',
  'hsl(154, 48.4%, 12.9%)',
  'hsl(154, 49.7%, 14.9%)',
  'hsl(154, 50.9%, 17.6%)',
  'hsl(153, 51.8%, 21.8%)',
  'hsl(151, 51.7%, 28.4%)',
  'hsl(151, 49.3%, 46.5%)',
  'hsl(151, 50.0%, 53.2%)',
  'hsl(137, 72.0%, 94.0%)',
  'hsl(30, 70.0%, 7.2%)',
  'hsl(28, 100%, 8.4%)',
  'hsl(26, 91.1%, 11.6%)',
  'hsl(25, 88.3%, 14.1%)',
  'hsl(24, 87.6%, 16.6%)',
  'hsl(24, 88.6%, 19.8%)',
  'hsl(24, 92.4%, 24.0%)',
  'hsl(25, 100%, 29.0%)',
  'hsl(24, 100%, 58.5%)',
  'hsl(24, 100%, 62.2%)',
  'hsl(24, 97.0%, 93.2%)',
  'hsla(0, 0%, 0%, 0)',
  'hsla(13, 100%, 49.7%, 0.054)',
  'hsla(20, 100%, 49.7%, 0.117)',
  'hsla(23, 100%, 49.8%, 0.166)',
  'hsla(23, 99.4%, 50.1%, 0.215)',
  'hsla(23, 99.8%, 51.1%, 0.286)',
  'hsla(23, 99.7%, 50.6%, 0.389)',
  'hsla(24, 100%, 49.9%, 0.523)',
  'hsla(24, 99.9%, 51.6%, 0.965)',
  'hsla(25, 100%, 58.6%, 0.980)',
  'hsla(24, 100%, 62.4%, 0.980)',
  'hsla(26, 100%, 94.2%, 0.980)',
  'hsl(318, 25.0%, 9.6%)',
  'hsl(319, 32.2%, 11.6%)',
  'hsl(319, 41.0%, 16.0%)',
  'hsl(320, 45.4%, 18.7%)',
  'hsl(320, 49.0%, 21.1%)',
  'hsl(321, 53.6%, 24.4%)',
  'hsl(321, 61.1%, 29.7%)',
  'hsl(322, 74.9%, 37.5%)',
  'hsl(323, 72.8%, 59.2%)',
  'hsl(325, 90.0%, 66.4%)',
  'hsl(322, 90.0%, 95.8%)',
  'hsl(284, 20.0%, 9.6%)',
  'hsl(283, 30.0%, 11.8%)',
  'hsl(281, 37.5%, 16.5%)',
  'hsl(280, 41.2%, 20.0%)',
  'hsl(279, 43.8%, 23.3%)',
  'hsl(277, 46.4%, 27.5%)',
  'hsl(275, 49.3%, 34.6%)',
  'hsl(272, 52.1%, 45.9%)',
  'hsl(273, 57.3%, 59.1%)',
  'hsl(275, 80.0%, 71.0%)',
  'hsl(279, 75.0%, 95.7%)',
  'hsl(353, 23.0%, 9.8%)',
  'hsl(357, 34.4%, 12.0%)',
  'hsl(356, 43.4%, 16.4%)',
  'hsl(356, 47.6%, 19.2%)',
  'hsl(356, 51.1%, 21.9%)',
  'hsl(356, 55.2%, 25.9%)',
  'hsl(357, 60.2%, 31.8%)',
  'hsl(358, 65.0%, 40.4%)',
  'hsl(358, 85.3%, 64.0%)',
  'hsl(358, 100%, 69.5%)',
  'hsl(351, 89.0%, 96.0%)',
  'hsl(45, 100%, 5.5%)',
  'hsl(46, 100%, 6.7%)',
  'hsl(45, 100%, 8.7%)',
  'hsl(45, 100%, 10.4%)',
  'hsl(47, 100%, 12.1%)',
  'hsl(49, 100%, 14.3%)',
  'hsl(49, 90.3%, 18.4%)',
  'hsl(50, 100%, 22.0%)',
  'hsl(54, 100%, 68.0%)',
  'hsl(48, 100%, 47.0%)',
  'hsl(53, 100%, 91.0%)',
  'hsl(17, 10.0%, 8.8%)',
  'hsl(15, 14.8%, 10.6%)',
  'hsl(15, 16.3%, 14.3%)',
  'hsl(16, 17.1%, 17.2%)',
  'hsl(16, 17.6%, 19.6%)',
  'hsl(16, 18.1%, 22.9%)',
  'hsl(17, 18.8%, 28.8%)',
  'hsl(17, 19.6%, 38.0%)',
  'hsl(18, 24.0%, 59.0%)',
  'hsl(18, 35.0%, 68.5%)',
  'hsl(18, 57.0%, 94.1%)',
  'hsl(44, 9.0%, 8.3%)',
  'hsl(43, 14.3%, 9.6%)',
  'hsl(42, 15.5%, 13.0%)',
  'hsl(41, 16.4%, 15.6%)',
  'hsl(41, 16.9%, 17.8%)',
  'hsl(40, 17.6%, 20.8%)',
  'hsl(38, 18.5%, 26.4%)',
  'hsl(36, 19.6%, 35.1%)',
  'hsl(36, 22.3%, 54.5%)',
  'hsl(35, 30.0%, 64.0%)',
  'hsl(49, 52.0%, 93.8%)',
  'rgba(0,0,0,0.3)',
  'rgba(0,0,0,0.2)',
  'hsla(24, 70.0%, 99.0%, 0)',
  'hsla(24, 70.0%, 99.0%, 0.25)',
  'hsla(24, 70.0%, 99.0%, 0.5)',
  'hsla(24, 70.0%, 99.0%, 0.75)',
  'hsla(24, 94.0%, 50.0%, 0)',
  'hsla(24, 94.0%, 50.0%, 0.25)',
  'hsla(24, 94.0%, 50.0%, 0.5)',
  'hsla(24, 94.0%, 50.0%, 0.75)',
  'hsla(60, 54.0%, 98.5%, 0)',
  'hsla(60, 54.0%, 98.5%, 0.25)',
  'hsla(60, 54.0%, 98.5%, 0.5)',
  'hsla(60, 54.0%, 98.5%, 0.75)',
  'hsla(53, 92.0%, 50.0%, 0)',
  'hsla(53, 92.0%, 50.0%, 0.25)',
  'hsla(53, 92.0%, 50.0%, 0.5)',
  'hsla(53, 92.0%, 50.0%, 0.75)',
  'hsla(136, 50.0%, 98.9%, 0)',
  'hsla(136, 50.0%, 98.9%, 0.25)',
  'hsla(136, 50.0%, 98.9%, 0.5)',
  'hsla(136, 50.0%, 98.9%, 0.75)',
  'hsla(151, 55.0%, 41.5%, 0)',
  'hsla(151, 55.0%, 41.5%, 0.25)',
  'hsla(151, 55.0%, 41.5%, 0.5)',
  'hsla(151, 55.0%, 41.5%, 0.75)',
  'hsla(206, 100%, 99.2%, 0)',
  'hsla(206, 100%, 99.2%, 0.25)',
  'hsla(206, 100%, 99.2%, 0.5)',
  'hsla(206, 100%, 99.2%, 0.75)',
  'hsla(206, 100%, 50.0%, 0)',
  'hsla(206, 100%, 50.0%, 0.25)',
  'hsla(206, 100%, 50.0%, 0.5)',
  'hsla(206, 100%, 50.0%, 0.75)',
  'hsla(280, 65.0%, 99.4%, 0)',
  'hsla(280, 65.0%, 99.4%, 0.25)',
  'hsla(280, 65.0%, 99.4%, 0.5)',
  'hsla(280, 65.0%, 99.4%, 0.75)',
  'hsla(272, 51.0%, 54.0%, 0)',
  'hsla(272, 51.0%, 54.0%, 0.25)',
  'hsla(272, 51.0%, 54.0%, 0.5)',
  'hsla(272, 51.0%, 54.0%, 0.75)',
  'hsla(322, 100%, 99.4%, 0)',
  'hsla(322, 100%, 99.4%, 0.25)',
  'hsla(322, 100%, 99.4%, 0.5)',
  'hsla(322, 100%, 99.4%, 0.75)',
  'hsla(322, 65.0%, 54.5%, 0)',
  'hsla(322, 65.0%, 54.5%, 0.25)',
  'hsla(322, 65.0%, 54.5%, 0.5)',
  'hsla(322, 65.0%, 54.5%, 0.75)',
  'hsla(359, 100%, 99.4%, 0)',
  'hsla(359, 100%, 99.4%, 0.25)',
  'hsla(359, 100%, 99.4%, 0.5)',
  'hsla(359, 100%, 99.4%, 0.75)',
  'hsla(358, 75.0%, 59.0%, 0)',
  'hsla(358, 75.0%, 59.0%, 0.25)',
  'hsla(358, 75.0%, 59.0%, 0.5)',
  'hsla(358, 75.0%, 59.0%, 0.75)',
  'hsla(0, 0%, 99.0%, 0)',
  'hsla(0, 0%, 99.0%, 0.25)',
  'hsla(0, 0%, 99.0%, 0.5)',
  'hsla(0, 0%, 99.0%, 0.75)',
  'hsla(0, 0%, 56.1%, 0)',
  'hsla(0, 0%, 56.1%, 0.25)',
  'hsla(0, 0%, 56.1%, 0.5)',
  'hsla(0, 0%, 56.1%, 0.75)',
  'hsla(15, 30.0%, 99.1%, 0)',
  'hsla(15, 30.0%, 99.1%, 0.25)',
  'hsla(15, 30.0%, 99.1%, 0.5)',
  'hsla(15, 30.0%, 99.1%, 0.75)',
  'hsla(17, 20.0%, 54.0%, 0)',
  'hsla(17, 20.0%, 54.0%, 0.25)',
  'hsla(17, 20.0%, 54.0%, 0.5)',
  'hsla(17, 20.0%, 54.0%, 0.75)',
  'hsla(50, 20.0%, 99.1%, 0)',
  'hsla(50, 20.0%, 99.1%, 0.25)',
  'hsla(50, 20.0%, 99.1%, 0.5)',
  'hsla(50, 20.0%, 99.1%, 0.75)',
  'hsla(36, 20.0%, 49.5%, 0)',
  'hsla(36, 20.0%, 49.5%, 0.25)',
  'hsla(36, 20.0%, 49.5%, 0.5)',
  'hsla(36, 20.0%, 49.5%, 0.75)',
  'hsla(30, 70.0%, 7.2%, 0)',
  'hsla(30, 70.0%, 7.2%, 0.25)',
  'hsla(30, 70.0%, 7.2%, 0.5)',
  'hsla(30, 70.0%, 7.2%, 0.75)',
  'hsla(45, 100%, 5.5%, 0)',
  'hsla(45, 100%, 5.5%, 0.25)',
  'hsla(45, 100%, 5.5%, 0.5)',
  'hsla(45, 100%, 5.5%, 0.75)',
  'hsla(146, 30.0%, 7.4%, 0)',
  'hsla(146, 30.0%, 7.4%, 0.25)',
  'hsla(146, 30.0%, 7.4%, 0.5)',
  'hsla(146, 30.0%, 7.4%, 0.75)',
  'hsla(212, 35.0%, 9.2%, 0)',
  'hsla(212, 35.0%, 9.2%, 0.25)',
  'hsla(212, 35.0%, 9.2%, 0.5)',
  'hsla(212, 35.0%, 9.2%, 0.75)',
  'hsla(284, 20.0%, 9.6%, 0)',
  'hsla(284, 20.0%, 9.6%, 0.25)',
  'hsla(284, 20.0%, 9.6%, 0.5)',
  'hsla(284, 20.0%, 9.6%, 0.75)',
  'hsla(318, 25.0%, 9.6%, 0)',
  'hsla(318, 25.0%, 9.6%, 0.25)',
  'hsla(318, 25.0%, 9.6%, 0.5)',
  'hsla(318, 25.0%, 9.6%, 0.75)',
  'hsla(353, 23.0%, 9.8%, 0)',
  'hsla(353, 23.0%, 9.8%, 0.25)',
  'hsla(353, 23.0%, 9.8%, 0.5)',
  'hsla(353, 23.0%, 9.8%, 0.75)',
  'hsla(0, 0%, 8.5%, 0)',
  'hsla(0, 0%, 8.5%, 0.25)',
  'hsla(0, 0%, 8.5%, 0.5)',
  'hsla(0, 0%, 8.5%, 0.75)',
  'hsla(0, 0%, 43.9%, 0)',
  'hsla(0, 0%, 43.9%, 0.25)',
  'hsla(0, 0%, 43.9%, 0.5)',
  'hsla(0, 0%, 43.9%, 0.75)',
  'hsla(17, 10.0%, 8.8%, 0)',
  'hsla(17, 10.0%, 8.8%, 0.25)',
  'hsla(17, 10.0%, 8.8%, 0.5)',
  'hsla(17, 10.0%, 8.8%, 0.75)',
  'hsla(44, 9.0%, 8.3%, 0)',
  'hsla(44, 9.0%, 8.3%, 0.25)',
  'hsla(44, 9.0%, 8.3%, 0.5)',
  'hsla(44, 9.0%, 8.3%, 0.75)',
  'rgba(0,0,0,0.5)',
  'rgba(0,0,0,0.8)',
]

const ks = [
'accentBackground',
'accentColor',
'background0',
'background025',
'background05',
'background075',
'color1',
'color2',
'color3',
'color4',
'color5',
'color6',
'color7',
'color8',
'color9',
'color10',
'color11',
'color12',
'color0',
'color025',
'color05',
'color075',
'background',
'backgroundHover',
'backgroundPress',
'backgroundFocus',
'borderColor',
'borderColorHover',
'borderColorPress',
'borderColorFocus',
'color',
'colorHover',
'colorPress',
'colorFocus',
'colorTransparent',
'placeholderColor',
'outlineColor',
'blue1',
'blue2',
'blue3',
'blue4',
'blue5',
'blue6',
'blue7',
'blue8',
'blue9',
'blue10',
'blue11',
'blue12',
'gray1',
'gray2',
'gray3',
'gray4',
'gray5',
'gray6',
'gray7',
'gray8',
'gray9',
'gray10',
'gray11',
'gray12',
'green1',
'green2',
'green3',
'green4',
'green5',
'green6',
'green7',
'green8',
'green9',
'green10',
'green11',
'green12',
'orange1',
'orange2',
'orange3',
'orange4',
'orange5',
'orange6',
'orange7',
'orange8',
'orange9',
'orange10',
'orange11',
'orange12',
'orangeA1',
'orangeA2',
'orangeA3',
'orangeA4',
'orangeA5',
'orangeA6',
'orangeA7',
'orangeA8',
'orangeA9',
'orangeA10',
'orangeA11',
'orangeA12',
'pink1',
'pink2',
'pink3',
'pink4',
'pink5',
'pink6',
'pink7',
'pink8',
'pink9',
'pink10',
'pink11',
'pink12',
'purple1',
'purple2',
'purple3',
'purple4',
'purple5',
'purple6',
'purple7',
'purple8',
'purple9',
'purple10',
'purple11',
'purple12',
'red1',
'red2',
'red3',
'red4',
'red5',
'red6',
'red7',
'red8',
'red9',
'red10',
'red11',
'red12',
'yellow1',
'yellow2',
'yellow3',
'yellow4',
'yellow5',
'yellow6',
'yellow7',
'yellow8',
'yellow9',
'yellow10',
'yellow11',
'yellow12',
'bronze1',
'bronze2',
'bronze3',
'bronze4',
'bronze5',
'bronze6',
'bronze7',
'bronze8',
'bronze9',
'bronze10',
'bronze11',
'bronze12',
'gold1',
'gold2',
'gold3',
'gold4',
'gold5',
'gold6',
'gold7',
'gold8',
'gold9',
'gold10',
'gold11',
'gold12',
'shadowColor',
'shadowColorHover',
'shadowColorPress',
'shadowColorFocus']


const n1 = t([[0, 0],[1, 1],[2, 2],[3, 3],[4, 4],[5, 5],[6, 6],[7, 7],[8, 8],[9, 9],[10, 10],[11, 11],[12, 12],[13, 13],[14, 14],[15, 15],[16, 16],[17, 17],[18, 18],[19, 19],[20, 20],[21, 21],[22, 6],[23, 5],[24, 7],[25, 7],[26, 9],[27, 8],[28, 10],[29, 9],[30, 17],[31, 16],[32, 17],[33, 16],[34, 18],[35, 14],[36, 19],[37, 22],[38, 23],[39, 24],[40, 0],[41, 25],[42, 26],[43, 27],[44, 28],[45, 29],[46, 30],[47, 31],[48, 32],[49, 33],[50, 34],[51, 35],[52, 36],[53, 37],[54, 38],[55, 39],[56, 40],[57, 14],[58, 41],[59, 42],[60, 17],[61, 43],[62, 44],[63, 45],[64, 46],[65, 47],[66, 48],[67, 49],[68, 50],[69, 51],[70, 52],[71, 53],[72, 54],[73, 55],[74, 56],[75, 57],[76, 58],[77, 59],[78, 60],[79, 61],[80, 62],[81, 63],[82, 64],[83, 65],[84, 66],[85, 67],[86, 68],[87, 69],[88, 70],[89, 71],[90, 72],[91, 73],[92, 74],[93, 75],[94, 76],[95, 77],[96, 78],[97, 79],[98, 80],[99, 81],[100, 82],[101, 83],[102, 84],[103, 85],[104, 86],[105, 87],[106, 88],[107, 89],[108, 90],[109, 91],[110, 92],[111, 93],[112, 94],[113, 95],[114, 96],[115, 97],[116, 98],[117, 99],[118, 100],[119, 101],[120, 102],[121, 103],[122, 104],[123, 105],[124, 106],[125, 107],[126, 108],[127, 109],[128, 110],[129, 111],[130, 112],[131, 113],[132, 114],[133, 115],[134, 116],[135, 117],[136, 118],[137, 119],[138, 120],[139, 121],[140, 122],[141, 123],[142, 124],[143, 125],[144, 126],[145, 127],[146, 128],[147, 129],[148, 130],[149, 131],[150, 132],[151, 133],[152, 134],[153, 135],[154, 136],[155, 137],[156, 138],[157, 139],[158, 140],[159, 141],[160, 142],[161, 143],[162, 144],[163, 145],[164, 146],[165, 147],[166, 148],[167, 149],[168, 150],[169, 151],[170, 151],[171, 152],[172, 152]])
const n2 = t([[0, 1],[1, 0],[2, 18],[3, 19],[4, 20],[5, 21],[6, 153],[7, 154],[8, 155],[9, 156],[10, 157],[11, 158],[12, 159],[13, 160],[14, 161],[15, 162],[16, 163],[17, 6],[18, 2],[19, 3],[20, 4],[21, 5],[22, 153],[23, 154],[24, 21],[25, 21],[26, 156],[27, 157],[28, 155],[29, 156],[30, 6],[31, 163],[32, 6],[33, 163],[34, 2],[35, 161],[36, 3],[37, 164],[38, 165],[39, 166],[40, 1],[41, 167],[42, 168],[43, 169],[44, 170],[45, 29],[46, 171],[47, 172],[48, 173],[49, 174],[50, 175],[51, 176],[52, 177],[53, 178],[54, 179],[55, 180],[56, 181],[57, 182],[58, 183],[59, 184],[60, 36],[61, 185],[62, 186],[63, 187],[64, 188],[65, 189],[66, 190],[67, 191],[68, 192],[69, 51],[70, 193],[71, 194],[72, 195],[73, 196],[74, 197],[75, 198],[76, 199],[77, 200],[78, 201],[79, 202],[80, 203],[81, 63],[82, 204],[83, 205],[84, 206],[85, 207],[86, 208],[87, 209],[88, 210],[89, 211],[90, 212],[91, 213],[92, 214],[93, 215],[94, 216],[95, 217],[96, 218],[97, 219],[98, 220],[99, 221],[100, 222],[101, 223],[102, 224],[103, 225],[104, 226],[105, 87],[106, 227],[107, 228],[108, 229],[109, 230],[110, 231],[111, 232],[112, 233],[113, 234],[114, 235],[115, 236],[116, 237],[117, 99],[118, 238],[119, 239],[120, 240],[121, 241],[122, 242],[123, 243],[124, 244],[125, 245],[126, 246],[127, 247],[128, 248],[129, 111],[130, 249],[131, 250],[132, 251],[133, 252],[134, 253],[135, 254],[136, 255],[137, 256],[138, 257],[139, 258],[140, 259],[141, 123],[142, 260],[143, 261],[144, 262],[145, 263],[146, 264],[147, 265],[148, 266],[149, 267],[150, 268],[151, 269],[152, 270],[153, 135],[154, 271],[155, 272],[156, 273],[157, 274],[158, 275],[159, 276],[160, 277],[161, 278],[162, 279],[163, 280],[164, 281],[165, 147],[166, 282],[167, 283],[168, 284],[169, 285],[170, 285],[171, 286],[172, 286]])
const n3 = t([[0, 67],[1, 78],[2, 287],[3, 288],[4, 289],[5, 290],[6, 55],[7, 56],[8, 57],[9, 58],[10, 59],[11, 60],[12, 61],[13, 62],[14, 63],[15, 64],[16, 65],[17, 66],[18, 291],[19, 292],[20, 293],[21, 294],[22, 55],[23, 290],[24, 56],[25, 56],[26, 58],[27, 57],[28, 59],[29, 58],[30, 66],[31, 65],[32, 66],[33, 65],[34, 291],[35, 63],[36, 292]])
const n4 = t([[0, 127],[1, 138],[2, 295],[3, 296],[4, 297],[5, 298],[6, 115],[7, 116],[8, 117],[9, 118],[10, 119],[11, 120],[12, 121],[13, 122],[14, 123],[15, 124],[16, 125],[17, 126],[18, 299],[19, 300],[20, 301],[21, 302],[22, 115],[23, 298],[24, 116],[25, 116],[26, 118],[27, 117],[28, 119],[29, 118],[30, 126],[31, 125],[32, 126],[33, 125],[34, 299],[35, 123],[36, 300]])
const n5 = t([[0, 55],[1, 66],[2, 303],[3, 304],[4, 305],[5, 306],[6, 43],[7, 44],[8, 45],[9, 46],[10, 47],[11, 48],[12, 49],[13, 50],[14, 51],[15, 52],[16, 53],[17, 54],[18, 307],[19, 308],[20, 309],[21, 310],[22, 43],[23, 306],[24, 44],[25, 44],[26, 46],[27, 45],[28, 47],[29, 46],[30, 54],[31, 53],[32, 54],[33, 53],[34, 307],[35, 51],[36, 308]])
const n6 = t([[0, 33],[1, 17],[2, 311],[3, 312],[4, 313],[5, 314],[6, 22],[7, 23],[8, 24],[9, 0],[10, 25],[11, 26],[12, 27],[13, 28],[14, 29],[15, 30],[16, 31],[17, 32],[18, 315],[19, 316],[20, 317],[21, 318],[22, 22],[23, 314],[24, 23],[25, 23],[26, 0],[27, 24],[28, 25],[29, 0],[30, 32],[31, 31],[32, 32],[33, 31],[34, 315],[35, 29],[36, 316]])
const n7 = t([[0, 103],[1, 114],[2, 319],[3, 320],[4, 321],[5, 322],[6, 91],[7, 92],[8, 93],[9, 94],[10, 95],[11, 96],[12, 97],[13, 98],[14, 99],[15, 100],[16, 101],[17, 102],[18, 323],[19, 324],[20, 325],[21, 326],[22, 91],[23, 322],[24, 92],[25, 92],[26, 94],[27, 93],[28, 95],[29, 94],[30, 102],[31, 101],[32, 102],[33, 101],[34, 323],[35, 99],[36, 324]])
const n8 = t([[0, 91],[1, 102],[2, 327],[3, 328],[4, 329],[5, 330],[6, 79],[7, 80],[8, 81],[9, 82],[10, 83],[11, 84],[12, 85],[13, 86],[14, 87],[15, 88],[16, 89],[17, 90],[18, 331],[19, 332],[20, 333],[21, 334],[22, 79],[23, 330],[24, 80],[25, 80],[26, 82],[27, 81],[28, 83],[29, 82],[30, 90],[31, 89],[32, 90],[33, 89],[34, 331],[35, 87],[36, 332]])
const n9 = t([[0, 115],[1, 126],[2, 335],[3, 336],[4, 337],[5, 338],[6, 103],[7, 104],[8, 105],[9, 106],[10, 107],[11, 108],[12, 109],[13, 110],[14, 111],[15, 112],[16, 113],[17, 114],[18, 339],[19, 340],[20, 341],[21, 342],[22, 103],[23, 338],[24, 104],[25, 104],[26, 106],[27, 105],[28, 107],[29, 106],[30, 114],[31, 113],[32, 114],[33, 113],[34, 339],[35, 111],[36, 340]])
const n10 = t([[0, 43],[1, 54],[2, 343],[3, 344],[4, 345],[5, 346],[6, 33],[7, 34],[8, 35],[9, 36],[10, 37],[11, 38],[12, 39],[13, 40],[14, 14],[15, 41],[16, 42],[17, 17],[18, 347],[19, 348],[20, 349],[21, 350],[22, 33],[23, 346],[24, 34],[25, 34],[26, 36],[27, 35],[28, 37],[29, 36],[30, 17],[31, 42],[32, 17],[33, 42],[34, 347],[35, 14],[36, 348]])
const n11 = t([[0, 139],[1, 150],[2, 351],[3, 352],[4, 353],[5, 354],[6, 127],[7, 128],[8, 129],[9, 130],[10, 131],[11, 132],[12, 133],[13, 134],[14, 135],[15, 136],[16, 137],[17, 138],[18, 355],[19, 356],[20, 357],[21, 358],[22, 127],[23, 354],[24, 128],[25, 128],[26, 130],[27, 129],[28, 131],[29, 130],[30, 138],[31, 137],[32, 138],[33, 137],[34, 355],[35, 135],[36, 356]])
const n12 = t([[0, 22],[1, 32],[2, 359],[3, 360],[4, 361],[5, 362],[6, 139],[7, 140],[8, 141],[9, 142],[10, 143],[11, 144],[12, 145],[13, 146],[14, 147],[15, 148],[16, 149],[17, 150],[18, 363],[19, 364],[20, 365],[21, 366],[22, 139],[23, 362],[24, 140],[25, 140],[26, 142],[27, 141],[28, 143],[29, 142],[30, 150],[31, 149],[32, 150],[33, 149],[34, 363],[35, 147],[36, 364]])
const n13 = t([[0, 79],[1, 90],[2, 67],[3, 67],[4, 67],[5, 67],[6, 67],[7, 68],[8, 69],[9, 70],[10, 71],[11, 72],[12, 73],[13, 74],[14, 75],[15, 76],[16, 77],[17, 78],[18, 75],[19, 75],[20, 75],[21, 75],[22, 67],[23, 67],[24, 68],[25, 68],[26, 70],[27, 69],[28, 71],[29, 70],[30, 78],[31, 77],[32, 78],[33, 77],[34, 75],[35, 75],[36, 75]])
const n14 = t([[0, 67],[1, 78],[2, 367],[3, 368],[4, 369],[5, 370],[6, 196],[7, 197],[8, 198],[9, 199],[10, 200],[11, 201],[12, 202],[13, 203],[14, 63],[15, 204],[16, 205],[17, 206],[18, 291],[19, 292],[20, 293],[21, 294],[22, 196],[23, 197],[24, 370],[25, 370],[26, 199],[27, 200],[28, 198],[29, 199],[30, 206],[31, 205],[32, 206],[33, 205],[34, 291],[35, 63],[36, 292]])
const n15 = t([[0, 127],[1, 138],[2, 371],[3, 372],[4, 373],[5, 374],[6, 252],[7, 253],[8, 254],[9, 255],[10, 256],[11, 257],[12, 258],[13, 259],[14, 123],[15, 260],[16, 261],[17, 262],[18, 299],[19, 300],[20, 301],[21, 302],[22, 252],[23, 253],[24, 374],[25, 374],[26, 255],[27, 256],[28, 254],[29, 255],[30, 262],[31, 261],[32, 262],[33, 261],[34, 299],[35, 123],[36, 300]])
const n16 = t([[0, 55],[1, 66],[2, 375],[3, 376],[4, 377],[5, 378],[6, 185],[7, 186],[8, 187],[9, 188],[10, 189],[11, 190],[12, 191],[13, 192],[14, 51],[15, 193],[16, 194],[17, 195],[18, 307],[19, 308],[20, 309],[21, 310],[22, 185],[23, 186],[24, 378],[25, 378],[26, 188],[27, 189],[28, 187],[29, 188],[30, 195],[31, 194],[32, 195],[33, 194],[34, 307],[35, 51],[36, 308]])
const n17 = t([[0, 33],[1, 17],[2, 379],[3, 380],[4, 381],[5, 382],[6, 164],[7, 165],[8, 166],[9, 1],[10, 167],[11, 168],[12, 169],[13, 170],[14, 29],[15, 171],[16, 172],[17, 173],[18, 315],[19, 316],[20, 317],[21, 318],[22, 164],[23, 165],[24, 382],[25, 382],[26, 1],[27, 167],[28, 166],[29, 1],[30, 173],[31, 172],[32, 173],[33, 172],[34, 315],[35, 29],[36, 316]])
const n18 = t([[0, 103],[1, 114],[2, 383],[3, 384],[4, 385],[5, 386],[6, 230],[7, 231],[8, 232],[9, 233],[10, 234],[11, 235],[12, 236],[13, 237],[14, 99],[15, 238],[16, 239],[17, 240],[18, 323],[19, 324],[20, 325],[21, 326],[22, 230],[23, 231],[24, 386],[25, 386],[26, 233],[27, 234],[28, 232],[29, 233],[30, 240],[31, 239],[32, 240],[33, 239],[34, 323],[35, 99],[36, 324]])
const n19 = t([[0, 91],[1, 102],[2, 387],[3, 388],[4, 389],[5, 390],[6, 219],[7, 220],[8, 221],[9, 222],[10, 223],[11, 224],[12, 225],[13, 226],[14, 87],[15, 227],[16, 228],[17, 229],[18, 331],[19, 332],[20, 333],[21, 334],[22, 219],[23, 220],[24, 390],[25, 390],[26, 222],[27, 223],[28, 221],[29, 222],[30, 229],[31, 228],[32, 229],[33, 228],[34, 331],[35, 87],[36, 332]])
const n20 = t([[0, 115],[1, 126],[2, 391],[3, 392],[4, 393],[5, 394],[6, 241],[7, 242],[8, 243],[9, 244],[10, 245],[11, 246],[12, 247],[13, 248],[14, 111],[15, 249],[16, 250],[17, 251],[18, 339],[19, 340],[20, 341],[21, 342],[22, 241],[23, 242],[24, 394],[25, 394],[26, 244],[27, 245],[28, 243],[29, 244],[30, 251],[31, 250],[32, 251],[33, 250],[34, 339],[35, 111],[36, 340]])
const n21 = t([[0, 43],[1, 54],[2, 395],[3, 396],[4, 397],[5, 398],[6, 174],[7, 175],[8, 176],[9, 177],[10, 178],[11, 179],[12, 180],[13, 181],[14, 182],[15, 183],[16, 184],[17, 36],[18, 399],[19, 400],[20, 401],[21, 402],[22, 174],[23, 175],[24, 398],[25, 398],[26, 177],[27, 178],[28, 176],[29, 177],[30, 36],[31, 184],[32, 36],[33, 184],[34, 399],[35, 182],[36, 400]])
const n22 = t([[0, 139],[1, 150],[2, 403],[3, 404],[4, 405],[5, 406],[6, 263],[7, 264],[8, 265],[9, 266],[10, 267],[11, 268],[12, 269],[13, 270],[14, 135],[15, 271],[16, 272],[17, 273],[18, 355],[19, 356],[20, 357],[21, 358],[22, 263],[23, 264],[24, 406],[25, 406],[26, 266],[27, 267],[28, 265],[29, 266],[30, 273],[31, 272],[32, 273],[33, 272],[34, 355],[35, 135],[36, 356]])
const n23 = t([[0, 22],[1, 32],[2, 407],[3, 408],[4, 409],[5, 410],[6, 274],[7, 275],[8, 276],[9, 277],[10, 278],[11, 279],[12, 280],[13, 281],[14, 147],[15, 282],[16, 283],[17, 284],[18, 363],[19, 364],[20, 365],[21, 366],[22, 274],[23, 275],[24, 410],[25, 410],[26, 277],[27, 278],[28, 276],[29, 277],[30, 284],[31, 283],[32, 284],[33, 283],[34, 363],[35, 147],[36, 364]])
const n24 = t([[0, 79],[1, 90],[2, 207],[3, 207],[4, 207],[5, 207],[6, 207],[7, 208],[8, 209],[9, 210],[10, 211],[11, 212],[12, 213],[13, 214],[14, 215],[15, 216],[16, 217],[17, 218],[18, 215],[19, 215],[20, 215],[21, 215],[22, 207],[23, 208],[24, 207],[25, 207],[26, 210],[27, 211],[28, 209],[29, 210],[30, 218],[31, 217],[32, 218],[33, 217],[34, 215],[35, 215],[36, 215]])
const n25 = t([[30, 16],[31, 15],[32, 16],[33, 15]])
const n26 = t([[30, 15],[31, 14],[32, 15],[33, 14]])
const n27 = t([[22, 9],[23, 8],[24, 10],[25, 10],[26, 12],[27, 11],[29, 12],[28, 13]])
const n28 = t([[22, 7],[23, 6],[24, 8],[25, 8],[26, 10],[27, 9],[29, 10],[28, 11]])
const n29 = t([[22, 8],[23, 7],[24, 9],[25, 9],[26, 11],[27, 10],[29, 11],[28, 12]])
const n30 = t([[22, 11],[23, 11],[24, 12],[25, 12],[26, 11],[27, 11],[29, 12],[28, 12]])
const n31 = t([[30, 163],[31, 162],[32, 163],[33, 162]])
const n32 = t([[30, 162],[31, 161],[32, 162],[33, 161]])
const n33 = t([[22, 156],[23, 157],[24, 155],[25, 155],[26, 159],[27, 160],[29, 159],[28, 158]])
const n34 = t([[22, 154],[23, 155],[24, 153],[25, 153],[26, 157],[27, 158],[29, 157],[28, 156]])
const n35 = t([[22, 155],[23, 156],[24, 154],[25, 154],[26, 158],[27, 159],[29, 158],[28, 157]])
const n36 = t([[22, 158],[23, 158],[24, 157],[25, 157],[26, 158],[27, 158],[29, 157],[28, 157]])
const n37 = t([[30, 65],[31, 64],[32, 65],[33, 64]])
const n38 = t([[30, 64],[31, 63],[32, 64],[33, 63]])
const n39 = t([[22, 58],[23, 57],[24, 59],[25, 59],[26, 61],[27, 60],[29, 61],[28, 62]])
const n40 = t([[22, 56],[23, 55],[24, 57],[25, 57],[26, 59],[27, 58],[29, 59],[28, 60]])
const n41 = t([[22, 57],[23, 56],[24, 58],[25, 58],[26, 60],[27, 59],[29, 60],[28, 61]])
const n42 = t([[22, 60],[23, 60],[24, 61],[25, 61],[26, 60],[27, 60],[29, 61],[28, 61]])
const n43 = t([[30, 125],[31, 124],[32, 125],[33, 124]])
const n44 = t([[30, 124],[31, 123],[32, 124],[33, 123]])
const n45 = t([[22, 118],[23, 117],[24, 119],[25, 119],[26, 121],[27, 120],[29, 121],[28, 122]])
const n46 = t([[22, 116],[23, 115],[24, 117],[25, 117],[26, 119],[27, 118],[29, 119],[28, 120]])
const n47 = t([[22, 117],[23, 116],[24, 118],[25, 118],[26, 120],[27, 119],[29, 120],[28, 121]])
const n48 = t([[22, 120],[23, 120],[24, 121],[25, 121],[26, 120],[27, 120],[29, 121],[28, 121]])
const n49 = t([[30, 53],[31, 52],[32, 53],[33, 52]])
const n50 = t([[30, 52],[31, 51],[32, 52],[33, 51]])
const n51 = t([[22, 46],[23, 45],[24, 47],[25, 47],[26, 49],[27, 48],[29, 49],[28, 50]])
const n52 = t([[22, 44],[23, 43],[24, 45],[25, 45],[26, 47],[27, 46],[29, 47],[28, 48]])
const n53 = t([[22, 45],[23, 44],[24, 46],[25, 46],[26, 48],[27, 47],[29, 48],[28, 49]])
const n54 = t([[22, 48],[23, 48],[24, 49],[25, 49],[26, 48],[27, 48],[29, 49],[28, 49]])
const n55 = t([[30, 31],[31, 30],[32, 31],[33, 30]])
const n56 = t([[30, 30],[31, 29],[32, 30],[33, 29]])
const n57 = t([[22, 0],[23, 24],[24, 25],[25, 25],[26, 27],[27, 26],[29, 27],[28, 28]])
const n58 = t([[22, 23],[23, 22],[24, 24],[25, 24],[26, 25],[27, 0],[29, 25],[28, 26]])
const n59 = t([[22, 24],[23, 23],[24, 0],[25, 0],[26, 26],[27, 25],[29, 26],[28, 27]])
const n60 = t([[22, 26],[23, 26],[24, 27],[25, 27],[26, 26],[27, 26],[29, 27],[28, 27]])
const n61 = t([[30, 101],[31, 100],[32, 101],[33, 100]])
const n62 = t([[30, 100],[31, 99],[32, 100],[33, 99]])
const n63 = t([[22, 94],[23, 93],[24, 95],[25, 95],[26, 97],[27, 96],[29, 97],[28, 98]])
const n64 = t([[22, 92],[23, 91],[24, 93],[25, 93],[26, 95],[27, 94],[29, 95],[28, 96]])
const n65 = t([[22, 93],[23, 92],[24, 94],[25, 94],[26, 96],[27, 95],[29, 96],[28, 97]])
const n66 = t([[22, 96],[23, 96],[24, 97],[25, 97],[26, 96],[27, 96],[29, 97],[28, 97]])
const n67 = t([[30, 89],[31, 88],[32, 89],[33, 88]])
const n68 = t([[30, 88],[31, 87],[32, 88],[33, 87]])
const n69 = t([[22, 82],[23, 81],[24, 83],[25, 83],[26, 85],[27, 84],[29, 85],[28, 86]])
const n70 = t([[22, 80],[23, 79],[24, 81],[25, 81],[26, 83],[27, 82],[29, 83],[28, 84]])
const n71 = t([[22, 81],[23, 80],[24, 82],[25, 82],[26, 84],[27, 83],[29, 84],[28, 85]])
const n72 = t([[22, 84],[23, 84],[24, 85],[25, 85],[26, 84],[27, 84],[29, 85],[28, 85]])
const n73 = t([[30, 113],[31, 112],[32, 113],[33, 112]])
const n74 = t([[30, 112],[31, 111],[32, 112],[33, 111]])
const n75 = t([[22, 106],[23, 105],[24, 107],[25, 107],[26, 109],[27, 108],[29, 109],[28, 110]])
const n76 = t([[22, 104],[23, 103],[24, 105],[25, 105],[26, 107],[27, 106],[29, 107],[28, 108]])
const n77 = t([[22, 105],[23, 104],[24, 106],[25, 106],[26, 108],[27, 107],[29, 108],[28, 109]])
const n78 = t([[22, 108],[23, 108],[24, 109],[25, 109],[26, 108],[27, 108],[29, 109],[28, 109]])
const n79 = t([[30, 42],[31, 41],[32, 42],[33, 41]])
const n80 = t([[30, 41],[31, 14],[32, 41],[33, 14]])
const n81 = t([[22, 36],[23, 35],[24, 37],[25, 37],[26, 39],[27, 38],[29, 39],[28, 40]])
const n82 = t([[22, 34],[23, 33],[24, 35],[25, 35],[26, 37],[27, 36],[29, 37],[28, 38]])
const n83 = t([[22, 35],[23, 34],[24, 36],[25, 36],[26, 38],[27, 37],[29, 38],[28, 39]])
const n84 = t([[22, 38],[23, 38],[24, 39],[25, 39],[26, 38],[27, 38],[29, 39],[28, 39]])
const n85 = t([[30, 137],[31, 136],[32, 137],[33, 136]])
const n86 = t([[30, 136],[31, 135],[32, 136],[33, 135]])
const n87 = t([[22, 130],[23, 129],[24, 131],[25, 131],[26, 133],[27, 132],[29, 133],[28, 134]])
const n88 = t([[22, 128],[23, 127],[24, 129],[25, 129],[26, 131],[27, 130],[29, 131],[28, 132]])
const n89 = t([[22, 129],[23, 128],[24, 130],[25, 130],[26, 132],[27, 131],[29, 132],[28, 133]])
const n90 = t([[22, 132],[23, 132],[24, 133],[25, 133],[26, 132],[27, 132],[29, 133],[28, 133]])
const n91 = t([[30, 149],[31, 148],[32, 149],[33, 148]])
const n92 = t([[30, 148],[31, 147],[32, 148],[33, 147]])
const n93 = t([[22, 142],[23, 141],[24, 143],[25, 143],[26, 145],[27, 144],[29, 145],[28, 146]])
const n94 = t([[22, 140],[23, 139],[24, 141],[25, 141],[26, 143],[27, 142],[29, 143],[28, 144]])
const n95 = t([[22, 141],[23, 140],[24, 142],[25, 142],[26, 144],[27, 143],[29, 144],[28, 145]])
const n96 = t([[22, 144],[23, 144],[24, 145],[25, 145],[26, 144],[27, 144],[29, 145],[28, 145]])
const n97 = t([[30, 77],[31, 76],[32, 77],[33, 76]])
const n98 = t([[30, 76],[31, 75],[32, 76],[33, 75]])
const n99 = t([[22, 70],[23, 69],[24, 71],[25, 71],[26, 73],[27, 72],[29, 73],[28, 74]])
const n100 = t([[22, 68],[23, 67],[24, 69],[25, 69],[26, 71],[27, 70],[29, 71],[28, 72]])
const n101 = t([[22, 69],[23, 68],[24, 70],[25, 70],[26, 72],[27, 71],[29, 72],[28, 73]])
const n102 = t([[22, 72],[23, 72],[24, 73],[25, 73],[26, 72],[27, 72],[29, 73],[28, 73]])
const n103 = t([[30, 205],[31, 204],[32, 205],[33, 204]])
const n104 = t([[30, 204],[31, 63],[32, 204],[33, 63]])
const n105 = t([[22, 199],[23, 200],[24, 198],[25, 198],[26, 202],[27, 203],[29, 202],[28, 201]])
const n106 = t([[22, 197],[23, 198],[24, 196],[25, 196],[26, 200],[27, 201],[29, 200],[28, 199]])
const n107 = t([[22, 198],[23, 199],[24, 197],[25, 197],[26, 201],[27, 202],[29, 201],[28, 200]])
const n108 = t([[22, 201],[23, 201],[24, 200],[25, 200],[26, 201],[27, 201],[29, 200],[28, 200]])
const n109 = t([[30, 261],[31, 260],[32, 261],[33, 260]])
const n110 = t([[30, 260],[31, 123],[32, 260],[33, 123]])
const n111 = t([[22, 255],[23, 256],[24, 254],[25, 254],[26, 258],[27, 259],[29, 258],[28, 257]])
const n112 = t([[22, 253],[23, 254],[24, 252],[25, 252],[26, 256],[27, 257],[29, 256],[28, 255]])
const n113 = t([[22, 254],[23, 255],[24, 253],[25, 253],[26, 257],[27, 258],[29, 257],[28, 256]])
const n114 = t([[22, 257],[23, 257],[24, 256],[25, 256],[26, 257],[27, 257],[29, 256],[28, 256]])
const n115 = t([[30, 194],[31, 193],[32, 194],[33, 193]])
const n116 = t([[30, 193],[31, 51],[32, 193],[33, 51]])
const n117 = t([[22, 188],[23, 189],[24, 187],[25, 187],[26, 191],[27, 192],[29, 191],[28, 190]])
const n118 = t([[22, 186],[23, 187],[24, 185],[25, 185],[26, 189],[27, 190],[29, 189],[28, 188]])
const n119 = t([[22, 187],[23, 188],[24, 186],[25, 186],[26, 190],[27, 191],[29, 190],[28, 189]])
const n120 = t([[22, 190],[23, 190],[24, 189],[25, 189],[26, 190],[27, 190],[29, 189],[28, 189]])
const n121 = t([[30, 172],[31, 171],[32, 172],[33, 171]])
const n122 = t([[30, 171],[31, 29],[32, 171],[33, 29]])
const n123 = t([[22, 1],[23, 167],[24, 166],[25, 166],[26, 169],[27, 170],[29, 169],[28, 168]])
const n124 = t([[22, 165],[23, 166],[24, 164],[25, 164],[26, 167],[27, 168],[29, 167],[28, 1]])
const n125 = t([[22, 166],[23, 1],[24, 165],[25, 165],[26, 168],[27, 169],[29, 168],[28, 167]])
const n126 = t([[22, 168],[23, 168],[24, 167],[25, 167],[26, 168],[27, 168],[29, 167],[28, 167]])
const n127 = t([[30, 239],[31, 238],[32, 239],[33, 238]])
const n128 = t([[30, 238],[31, 99],[32, 238],[33, 99]])
const n129 = t([[22, 233],[23, 234],[24, 232],[25, 232],[26, 236],[27, 237],[29, 236],[28, 235]])
const n130 = t([[22, 231],[23, 232],[24, 230],[25, 230],[26, 234],[27, 235],[29, 234],[28, 233]])
const n131 = t([[22, 232],[23, 233],[24, 231],[25, 231],[26, 235],[27, 236],[29, 235],[28, 234]])
const n132 = t([[22, 235],[23, 235],[24, 234],[25, 234],[26, 235],[27, 235],[29, 234],[28, 234]])
const n133 = t([[30, 228],[31, 227],[32, 228],[33, 227]])
const n134 = t([[30, 227],[31, 87],[32, 227],[33, 87]])
const n135 = t([[22, 222],[23, 223],[24, 221],[25, 221],[26, 225],[27, 226],[29, 225],[28, 224]])
const n136 = t([[22, 220],[23, 221],[24, 219],[25, 219],[26, 223],[27, 224],[29, 223],[28, 222]])
const n137 = t([[22, 221],[23, 222],[24, 220],[25, 220],[26, 224],[27, 225],[29, 224],[28, 223]])
const n138 = t([[22, 224],[23, 224],[24, 223],[25, 223],[26, 224],[27, 224],[29, 223],[28, 223]])
const n139 = t([[30, 250],[31, 249],[32, 250],[33, 249]])
const n140 = t([[30, 249],[31, 111],[32, 249],[33, 111]])
const n141 = t([[22, 244],[23, 245],[24, 243],[25, 243],[26, 247],[27, 248],[29, 247],[28, 246]])
const n142 = t([[22, 242],[23, 243],[24, 241],[25, 241],[26, 245],[27, 246],[29, 245],[28, 244]])
const n143 = t([[22, 243],[23, 244],[24, 242],[25, 242],[26, 246],[27, 247],[29, 246],[28, 245]])
const n144 = t([[22, 246],[23, 246],[24, 245],[25, 245],[26, 246],[27, 246],[29, 245],[28, 245]])
const n145 = t([[30, 184],[31, 183],[32, 184],[33, 183]])
const n146 = t([[30, 183],[31, 182],[32, 183],[33, 182]])
const n147 = t([[22, 177],[23, 178],[24, 176],[25, 176],[26, 180],[27, 181],[29, 180],[28, 179]])
const n148 = t([[22, 175],[23, 176],[24, 174],[25, 174],[26, 178],[27, 179],[29, 178],[28, 177]])
const n149 = t([[22, 176],[23, 177],[24, 175],[25, 175],[26, 179],[27, 180],[29, 179],[28, 178]])
const n150 = t([[22, 179],[23, 179],[24, 178],[25, 178],[26, 179],[27, 179],[29, 178],[28, 178]])
const n151 = t([[30, 272],[31, 271],[32, 272],[33, 271]])
const n152 = t([[30, 271],[31, 135],[32, 271],[33, 135]])
const n153 = t([[22, 266],[23, 267],[24, 265],[25, 265],[26, 269],[27, 270],[29, 269],[28, 268]])
const n154 = t([[22, 264],[23, 265],[24, 263],[25, 263],[26, 267],[27, 268],[29, 267],[28, 266]])
const n155 = t([[22, 265],[23, 266],[24, 264],[25, 264],[26, 268],[27, 269],[29, 268],[28, 267]])
const n156 = t([[22, 268],[23, 268],[24, 267],[25, 267],[26, 268],[27, 268],[29, 267],[28, 267]])
const n157 = t([[30, 283],[31, 282],[32, 283],[33, 282]])
const n158 = t([[30, 282],[31, 147],[32, 282],[33, 147]])
const n159 = t([[22, 277],[23, 278],[24, 276],[25, 276],[26, 280],[27, 281],[29, 280],[28, 279]])
const n160 = t([[22, 275],[23, 276],[24, 274],[25, 274],[26, 278],[27, 279],[29, 278],[28, 277]])
const n161 = t([[22, 276],[23, 277],[24, 275],[25, 275],[26, 279],[27, 280],[29, 279],[28, 278]])
const n162 = t([[22, 279],[23, 279],[24, 278],[25, 278],[26, 279],[27, 279],[29, 278],[28, 278]])
const n163 = t([[30, 217],[31, 216],[32, 217],[33, 216]])
const n164 = t([[30, 216],[31, 215],[32, 216],[33, 215]])
const n165 = t([[22, 210],[23, 211],[24, 209],[25, 209],[26, 213],[27, 214],[29, 213],[28, 212]])
const n166 = t([[22, 208],[23, 209],[24, 207],[25, 207],[26, 211],[27, 212],[29, 211],[28, 210]])
const n167 = t([[22, 209],[23, 210],[24, 208],[25, 208],[26, 212],[27, 213],[29, 212],[28, 211]])
const n168 = t([[22, 212],[23, 212],[24, 211],[25, 211],[26, 212],[27, 212],[29, 211],[28, 211]])
const n169 = t([[30, 7],[31, 6],[32, 8],[33, 8],[22, 17],[23, 16],[24, 17],[25, 16],[26, 15],[27, 14],[29, 13],[28, 12]])
const n170 = t([[22, 411]])
const n171 = t([[30, 154],[31, 155],[32, 153],[33, 153],[22, 6],[23, 163],[24, 6],[25, 163],[26, 162],[27, 161],[29, 160],[28, 159]])
const n172 = t([[22, 412]])
const n173 = t([[30, 56],[31, 55],[32, 57],[33, 57],[22, 66],[23, 65],[24, 66],[25, 65],[26, 64],[27, 63],[29, 62],[28, 61]])
const n174 = t([[30, 116],[31, 115],[32, 117],[33, 117],[22, 126],[23, 125],[24, 126],[25, 125],[26, 124],[27, 123],[29, 122],[28, 121]])
const n175 = t([[30, 44],[31, 43],[32, 45],[33, 45],[22, 54],[23, 53],[24, 54],[25, 53],[26, 52],[27, 51],[29, 50],[28, 49]])
const n176 = t([[30, 23],[31, 22],[32, 24],[33, 24],[22, 32],[23, 31],[24, 32],[25, 31],[26, 30],[27, 29],[29, 28],[28, 27]])
const n177 = t([[30, 92],[31, 91],[32, 93],[33, 93],[22, 102],[23, 101],[24, 102],[25, 101],[26, 100],[27, 99],[29, 98],[28, 97]])
const n178 = t([[30, 80],[31, 79],[32, 81],[33, 81],[22, 90],[23, 89],[24, 90],[25, 89],[26, 88],[27, 87],[29, 86],[28, 85]])
const n179 = t([[30, 104],[31, 103],[32, 105],[33, 105],[22, 114],[23, 113],[24, 114],[25, 113],[26, 112],[27, 111],[29, 110],[28, 109]])
const n180 = t([[30, 34],[31, 33],[32, 35],[33, 35],[22, 17],[23, 42],[24, 17],[25, 42],[26, 41],[27, 14],[29, 40],[28, 39]])
const n181 = t([[30, 128],[31, 127],[32, 129],[33, 129],[22, 138],[23, 137],[24, 138],[25, 137],[26, 136],[27, 135],[29, 134],[28, 133]])
const n182 = t([[30, 140],[31, 139],[32, 141],[33, 141],[22, 150],[23, 149],[24, 150],[25, 149],[26, 148],[27, 147],[29, 146],[28, 145]])
const n183 = t([[30, 68],[31, 67],[32, 69],[33, 69],[22, 78],[23, 77],[24, 78],[25, 77],[26, 76],[27, 75],[29, 74],[28, 73]])
const n184 = t([[30, 197],[31, 198],[32, 196],[33, 196],[22, 206],[23, 205],[24, 206],[25, 205],[26, 204],[27, 63],[29, 203],[28, 202]])
const n185 = t([[30, 253],[31, 254],[32, 252],[33, 252],[22, 262],[23, 261],[24, 262],[25, 261],[26, 260],[27, 123],[29, 259],[28, 258]])
const n186 = t([[30, 186],[31, 187],[32, 185],[33, 185],[22, 195],[23, 194],[24, 195],[25, 194],[26, 193],[27, 51],[29, 192],[28, 191]])
const n187 = t([[30, 165],[31, 166],[32, 164],[33, 164],[22, 173],[23, 172],[24, 173],[25, 172],[26, 171],[27, 29],[29, 170],[28, 169]])
const n188 = t([[30, 231],[31, 232],[32, 230],[33, 230],[22, 240],[23, 239],[24, 240],[25, 239],[26, 238],[27, 99],[29, 237],[28, 236]])
const n189 = t([[30, 220],[31, 221],[32, 219],[33, 219],[22, 229],[23, 228],[24, 229],[25, 228],[26, 227],[27, 87],[29, 226],[28, 225]])
const n190 = t([[30, 242],[31, 243],[32, 241],[33, 241],[22, 251],[23, 250],[24, 251],[25, 250],[26, 249],[27, 111],[29, 248],[28, 247]])
const n191 = t([[30, 175],[31, 176],[32, 174],[33, 174],[22, 36],[23, 184],[24, 36],[25, 184],[26, 183],[27, 182],[29, 181],[28, 180]])
const n192 = t([[30, 264],[31, 265],[32, 263],[33, 263],[22, 273],[23, 272],[24, 273],[25, 272],[26, 271],[27, 135],[29, 270],[28, 269]])
const n193 = t([[30, 275],[31, 276],[32, 274],[33, 274],[22, 284],[23, 283],[24, 284],[25, 283],[26, 282],[27, 147],[29, 281],[28, 280]])
const n194 = t([[30, 208],[31, 209],[32, 207],[33, 207],[22, 218],[23, 217],[24, 218],[25, 217],[26, 216],[27, 215],[29, 214],[28, 213]])
const n195 = t([[30, 7],[31, 6],[32, 8],[33, 8],[22, 15],[23, 14],[24, 15],[25, 14],[26, 13],[27, 12],[29, 11],[28, 10]])
const n196 = t([[30, 154],[31, 155],[32, 153],[33, 153],[22, 162],[23, 161],[24, 162],[25, 161],[26, 160],[27, 159],[29, 158],[28, 157]])
const n197 = t([[30, 56],[31, 55],[32, 57],[33, 57],[22, 64],[23, 63],[24, 64],[25, 63],[26, 62],[27, 61],[29, 60],[28, 59]])
const n198 = t([[30, 116],[31, 115],[32, 117],[33, 117],[22, 124],[23, 123],[24, 124],[25, 123],[26, 122],[27, 121],[29, 120],[28, 119]])
const n199 = t([[30, 44],[31, 43],[32, 45],[33, 45],[22, 52],[23, 51],[24, 52],[25, 51],[26, 50],[27, 49],[29, 48],[28, 47]])
const n200 = t([[30, 23],[31, 22],[32, 24],[33, 24],[22, 30],[23, 29],[24, 30],[25, 29],[26, 28],[27, 27],[29, 26],[28, 25]])
const n201 = t([[30, 92],[31, 91],[32, 93],[33, 93],[22, 100],[23, 99],[24, 100],[25, 99],[26, 98],[27, 97],[29, 96],[28, 95]])
const n202 = t([[30, 80],[31, 79],[32, 81],[33, 81],[22, 88],[23, 87],[24, 88],[25, 87],[26, 86],[27, 85],[29, 84],[28, 83]])
const n203 = t([[30, 104],[31, 103],[32, 105],[33, 105],[22, 112],[23, 111],[24, 112],[25, 111],[26, 110],[27, 109],[29, 108],[28, 107]])
const n204 = t([[30, 34],[31, 33],[32, 35],[33, 35],[22, 41],[23, 14],[24, 41],[25, 14],[26, 40],[27, 39],[29, 38],[28, 37]])
const n205 = t([[30, 128],[31, 127],[32, 129],[33, 129],[22, 136],[23, 135],[24, 136],[25, 135],[26, 134],[27, 133],[29, 132],[28, 131]])
const n206 = t([[30, 140],[31, 139],[32, 141],[33, 141],[22, 148],[23, 147],[24, 148],[25, 147],[26, 146],[27, 145],[29, 144],[28, 143]])
const n207 = t([[30, 68],[31, 67],[32, 69],[33, 69],[22, 76],[23, 75],[24, 76],[25, 75],[26, 74],[27, 73],[29, 72],[28, 71]])
const n208 = t([[30, 197],[31, 198],[32, 196],[33, 196],[22, 204],[23, 63],[24, 204],[25, 63],[26, 203],[27, 202],[29, 201],[28, 200]])
const n209 = t([[30, 253],[31, 254],[32, 252],[33, 252],[22, 260],[23, 123],[24, 260],[25, 123],[26, 259],[27, 258],[29, 257],[28, 256]])
const n210 = t([[30, 186],[31, 187],[32, 185],[33, 185],[22, 193],[23, 51],[24, 193],[25, 51],[26, 192],[27, 191],[29, 190],[28, 189]])
const n211 = t([[30, 165],[31, 166],[32, 164],[33, 164],[22, 171],[23, 29],[24, 171],[25, 29],[26, 170],[27, 169],[29, 168],[28, 167]])
const n212 = t([[30, 231],[31, 232],[32, 230],[33, 230],[22, 238],[23, 99],[24, 238],[25, 99],[26, 237],[27, 236],[29, 235],[28, 234]])
const n213 = t([[30, 220],[31, 221],[32, 219],[33, 219],[22, 227],[23, 87],[24, 227],[25, 87],[26, 226],[27, 225],[29, 224],[28, 223]])
const n214 = t([[30, 242],[31, 243],[32, 241],[33, 241],[22, 249],[23, 111],[24, 249],[25, 111],[26, 248],[27, 247],[29, 246],[28, 245]])
const n215 = t([[30, 175],[31, 176],[32, 174],[33, 174],[22, 183],[23, 182],[24, 183],[25, 182],[26, 181],[27, 180],[29, 179],[28, 178]])
const n216 = t([[30, 264],[31, 265],[32, 263],[33, 263],[22, 271],[23, 135],[24, 271],[25, 135],[26, 270],[27, 269],[29, 268],[28, 267]])
const n217 = t([[30, 275],[31, 276],[32, 274],[33, 274],[22, 282],[23, 147],[24, 282],[25, 147],[26, 281],[27, 280],[29, 279],[28, 278]])
const n218 = t([[30, 208],[31, 209],[32, 207],[33, 207],[22, 216],[23, 215],[24, 216],[25, 215],[26, 214],[27, 213],[29, 212],[28, 211]])

type ThemeNames =
 | 'light'
 | 'dark'
 | 'light_orange'
 | 'light_yellow'
 | 'light_green'
 | 'light_blue'
 | 'light_purple'
 | 'light_pink'
 | 'light_red'
 | 'light_gray'
 | 'light_bronze'
 | 'light_gold'
 | 'dark_orange'
 | 'dark_yellow'
 | 'dark_green'
 | 'dark_blue'
 | 'dark_purple'
 | 'dark_pink'
 | 'dark_red'
 | 'dark_gray'
 | 'dark_bronze'
 | 'dark_gold'
 | 'light_alt1'
 | 'light_alt2'
 | 'light_active'
 | 'light_surface3'
 | 'light_surface1'
 | 'light_surface2'
 | 'light_surface4'
 | 'dark_alt1'
 | 'dark_alt2'
 | 'dark_active'
 | 'dark_surface3'
 | 'dark_surface1'
 | 'dark_surface2'
 | 'dark_surface4'
 | 'light_orange_alt1'
 | 'light_orange_alt2'
 | 'light_orange_active'
 | 'light_orange_surface3'
 | 'light_orange_surface1'
 | 'light_orange_surface2'
 | 'light_orange_surface4'
 | 'light_yellow_alt1'
 | 'light_yellow_alt2'
 | 'light_yellow_active'
 | 'light_yellow_surface3'
 | 'light_yellow_surface1'
 | 'light_yellow_surface2'
 | 'light_yellow_surface4'
 | 'light_green_alt1'
 | 'light_green_alt2'
 | 'light_green_active'
 | 'light_green_surface3'
 | 'light_green_surface1'
 | 'light_green_surface2'
 | 'light_green_surface4'
 | 'light_blue_alt1'
 | 'light_blue_alt2'
 | 'light_blue_active'
 | 'light_blue_surface3'
 | 'light_blue_surface1'
 | 'light_blue_surface2'
 | 'light_blue_surface4'
 | 'light_purple_alt1'
 | 'light_purple_alt2'
 | 'light_purple_active'
 | 'light_purple_surface3'
 | 'light_purple_surface1'
 | 'light_purple_surface2'
 | 'light_purple_surface4'
 | 'light_pink_alt1'
 | 'light_pink_alt2'
 | 'light_pink_active'
 | 'light_pink_surface3'
 | 'light_pink_surface1'
 | 'light_pink_surface2'
 | 'light_pink_surface4'
 | 'light_red_alt1'
 | 'light_red_alt2'
 | 'light_red_active'
 | 'light_red_surface3'
 | 'light_red_surface1'
 | 'light_red_surface2'
 | 'light_red_surface4'
 | 'light_gray_alt1'
 | 'light_gray_alt2'
 | 'light_gray_active'
 | 'light_gray_surface3'
 | 'light_gray_surface1'
 | 'light_gray_surface2'
 | 'light_gray_surface4'
 | 'light_bronze_alt1'
 | 'light_bronze_alt2'
 | 'light_bronze_active'
 | 'light_bronze_surface3'
 | 'light_bronze_surface1'
 | 'light_bronze_surface2'
 | 'light_bronze_surface4'
 | 'light_gold_alt1'
 | 'light_gold_alt2'
 | 'light_gold_active'
 | 'light_gold_surface3'
 | 'light_gold_surface1'
 | 'light_gold_surface2'
 | 'light_gold_surface4'
 | 'dark_orange_alt1'
 | 'dark_orange_alt2'
 | 'dark_orange_active'
 | 'dark_orange_surface3'
 | 'dark_orange_surface1'
 | 'dark_orange_surface2'
 | 'dark_orange_surface4'
 | 'dark_yellow_alt1'
 | 'dark_yellow_alt2'
 | 'dark_yellow_active'
 | 'dark_yellow_surface3'
 | 'dark_yellow_surface1'
 | 'dark_yellow_surface2'
 | 'dark_yellow_surface4'
 | 'dark_green_alt1'
 | 'dark_green_alt2'
 | 'dark_green_active'
 | 'dark_green_surface3'
 | 'dark_green_surface1'
 | 'dark_green_surface2'
 | 'dark_green_surface4'
 | 'dark_blue_alt1'
 | 'dark_blue_alt2'
 | 'dark_blue_active'
 | 'dark_blue_surface3'
 | 'dark_blue_surface1'
 | 'dark_blue_surface2'
 | 'dark_blue_surface4'
 | 'dark_purple_alt1'
 | 'dark_purple_alt2'
 | 'dark_purple_active'
 | 'dark_purple_surface3'
 | 'dark_purple_surface1'
 | 'dark_purple_surface2'
 | 'dark_purple_surface4'
 | 'dark_pink_alt1'
 | 'dark_pink_alt2'
 | 'dark_pink_active'
 | 'dark_pink_surface3'
 | 'dark_pink_surface1'
 | 'dark_pink_surface2'
 | 'dark_pink_surface4'
 | 'dark_red_alt1'
 | 'dark_red_alt2'
 | 'dark_red_active'
 | 'dark_red_surface3'
 | 'dark_red_surface1'
 | 'dark_red_surface2'
 | 'dark_red_surface4'
 | 'dark_gray_alt1'
 | 'dark_gray_alt2'
 | 'dark_gray_active'
 | 'dark_gray_surface3'
 | 'dark_gray_surface1'
 | 'dark_gray_surface2'
 | 'dark_gray_surface4'
 | 'dark_bronze_alt1'
 | 'dark_bronze_alt2'
 | 'dark_bronze_active'
 | 'dark_bronze_surface3'
 | 'dark_bronze_surface1'
 | 'dark_bronze_surface2'
 | 'dark_bronze_surface4'
 | 'dark_gold_alt1'
 | 'dark_gold_alt2'
 | 'dark_gold_active'
 | 'dark_gold_surface3'
 | 'dark_gold_surface1'
 | 'dark_gold_surface2'
 | 'dark_gold_surface4'

export const themes: Record<ThemeNames, Theme> = {
  light: n1,
  dark: n2,
  light_orange: n3,
  light_yellow: n4,
  light_green: n5,
  light_blue: n6,
  light_purple: n7,
  light_pink: n8,
  light_red: n9,
  light_gray: n10,
  light_bronze: n11,
  light_gold: n12,
  light_orangeA: n13,
  dark_orange: n14,
  dark_yellow: n15,
  dark_green: n16,
  dark_blue: n17,
  dark_purple: n18,
  dark_pink: n19,
  dark_red: n20,
  dark_gray: n21,
  dark_bronze: n22,
  dark_gold: n23,
  dark_orangeA: n24,
  light_alt1: n25,
  light_alt2: n26,
  light_active: n27,
  light_surface3: n27,
  light_Button: n27,
  light_SliderTrackActive: n27,
  light_active_SliderTrackActive: n27,
  light_surface1: n28,
  light_ListItem: n28,
  light_SelectTrigger: n28,
  light_Card: n28,
  light_Progress: n28,
  light_TooltipArrow: n28,
  light_SliderTrack: n28,
  light_Input: n28,
  light_TextArea: n28,
  light_active_ListItem: n28,
  light_active_Progress: n28,
  light_active_TooltipArrow: n28,
  light_active_SliderTrack: n28,
  light_surface2: n29,
  light_Checkbox: n29,
  light_Switch: n29,
  light_TooltipContent: n29,
  light_RadioGroupItem: n29,
  light_surface4: n30,
  light_active_SelectTrigger: n30,
  light_active_Card: n30,
  light_active_Button: n30,
  light_active_Checkbox: n30,
  light_active_Switch: n30,
  light_active_TooltipContent: n30,
  light_active_RadioGroupItem: n30,
  light_active_Input: n30,
  light_active_TextArea: n30,
  dark_alt1: n31,
  dark_alt2: n32,
  dark_active: n33,
  dark_surface3: n33,
  dark_Button: n33,
  dark_SliderTrackActive: n33,
  dark_active_SliderTrackActive: n33,
  dark_surface1: n34,
  dark_ListItem: n34,
  dark_SelectTrigger: n34,
  dark_Card: n34,
  dark_Progress: n34,
  dark_TooltipArrow: n34,
  dark_SliderTrack: n34,
  dark_Input: n34,
  dark_TextArea: n34,
  dark_active_ListItem: n34,
  dark_active_Progress: n34,
  dark_active_TooltipArrow: n34,
  dark_active_SliderTrack: n34,
  dark_surface2: n35,
  dark_Checkbox: n35,
  dark_Switch: n35,
  dark_TooltipContent: n35,
  dark_RadioGroupItem: n35,
  dark_surface4: n36,
  dark_active_SelectTrigger: n36,
  dark_active_Card: n36,
  dark_active_Button: n36,
  dark_active_Checkbox: n36,
  dark_active_Switch: n36,
  dark_active_TooltipContent: n36,
  dark_active_RadioGroupItem: n36,
  dark_active_Input: n36,
  dark_active_TextArea: n36,
  light_orange_alt1: n37,
  light_orange_alt2: n38,
  light_orange_active: n39,
  light_orange_surface3: n39,
  light_orange_Button: n39,
  light_orange_SliderTrackActive: n39,
  light_orange_active_SliderTrackActive: n39,
  light_orange_surface1: n40,
  light_orange_ListItem: n40,
  light_orange_SelectTrigger: n40,
  light_orange_Card: n40,
  light_orange_Progress: n40,
  light_orange_TooltipArrow: n40,
  light_orange_SliderTrack: n40,
  light_orange_Input: n40,
  light_orange_TextArea: n40,
  light_orange_active_ListItem: n40,
  light_orange_active_Progress: n40,
  light_orange_active_TooltipArrow: n40,
  light_orange_active_SliderTrack: n40,
  light_orange_surface2: n41,
  light_orange_Checkbox: n41,
  light_orange_Switch: n41,
  light_orange_TooltipContent: n41,
  light_orange_RadioGroupItem: n41,
  light_orange_surface4: n42,
  light_orange_active_SelectTrigger: n42,
  light_orange_active_Card: n42,
  light_orange_active_Button: n42,
  light_orange_active_Checkbox: n42,
  light_orange_active_Switch: n42,
  light_orange_active_TooltipContent: n42,
  light_orange_active_RadioGroupItem: n42,
  light_orange_active_Input: n42,
  light_orange_active_TextArea: n42,
  light_yellow_alt1: n43,
  light_yellow_alt2: n44,
  light_yellow_active: n45,
  light_yellow_surface3: n45,
  light_yellow_Button: n45,
  light_yellow_SliderTrackActive: n45,
  light_yellow_active_SliderTrackActive: n45,
  light_yellow_surface1: n46,
  light_yellow_ListItem: n46,
  light_yellow_SelectTrigger: n46,
  light_yellow_Card: n46,
  light_yellow_Progress: n46,
  light_yellow_TooltipArrow: n46,
  light_yellow_SliderTrack: n46,
  light_yellow_Input: n46,
  light_yellow_TextArea: n46,
  light_yellow_active_ListItem: n46,
  light_yellow_active_Progress: n46,
  light_yellow_active_TooltipArrow: n46,
  light_yellow_active_SliderTrack: n46,
  light_yellow_surface2: n47,
  light_yellow_Checkbox: n47,
  light_yellow_Switch: n47,
  light_yellow_TooltipContent: n47,
  light_yellow_RadioGroupItem: n47,
  light_yellow_surface4: n48,
  light_yellow_active_SelectTrigger: n48,
  light_yellow_active_Card: n48,
  light_yellow_active_Button: n48,
  light_yellow_active_Checkbox: n48,
  light_yellow_active_Switch: n48,
  light_yellow_active_TooltipContent: n48,
  light_yellow_active_RadioGroupItem: n48,
  light_yellow_active_Input: n48,
  light_yellow_active_TextArea: n48,
  light_green_alt1: n49,
  light_green_alt2: n50,
  light_green_active: n51,
  light_green_surface3: n51,
  light_green_Button: n51,
  light_green_SliderTrackActive: n51,
  light_green_active_SliderTrackActive: n51,
  light_green_surface1: n52,
  light_green_ListItem: n52,
  light_green_SelectTrigger: n52,
  light_green_Card: n52,
  light_green_Progress: n52,
  light_green_TooltipArrow: n52,
  light_green_SliderTrack: n52,
  light_green_Input: n52,
  light_green_TextArea: n52,
  light_green_active_ListItem: n52,
  light_green_active_Progress: n52,
  light_green_active_TooltipArrow: n52,
  light_green_active_SliderTrack: n52,
  light_green_surface2: n53,
  light_green_Checkbox: n53,
  light_green_Switch: n53,
  light_green_TooltipContent: n53,
  light_green_RadioGroupItem: n53,
  light_green_surface4: n54,
  light_green_active_SelectTrigger: n54,
  light_green_active_Card: n54,
  light_green_active_Button: n54,
  light_green_active_Checkbox: n54,
  light_green_active_Switch: n54,
  light_green_active_TooltipContent: n54,
  light_green_active_RadioGroupItem: n54,
  light_green_active_Input: n54,
  light_green_active_TextArea: n54,
  light_blue_alt1: n55,
  light_blue_alt2: n56,
  light_blue_active: n57,
  light_blue_surface3: n57,
  light_blue_Button: n57,
  light_blue_SliderTrackActive: n57,
  light_blue_active_SliderTrackActive: n57,
  light_blue_surface1: n58,
  light_blue_ListItem: n58,
  light_blue_SelectTrigger: n58,
  light_blue_Card: n58,
  light_blue_Progress: n58,
  light_blue_TooltipArrow: n58,
  light_blue_SliderTrack: n58,
  light_blue_Input: n58,
  light_blue_TextArea: n58,
  light_blue_active_ListItem: n58,
  light_blue_active_Progress: n58,
  light_blue_active_TooltipArrow: n58,
  light_blue_active_SliderTrack: n58,
  light_blue_surface2: n59,
  light_blue_Checkbox: n59,
  light_blue_Switch: n59,
  light_blue_TooltipContent: n59,
  light_blue_RadioGroupItem: n59,
  light_blue_surface4: n60,
  light_blue_active_SelectTrigger: n60,
  light_blue_active_Card: n60,
  light_blue_active_Button: n60,
  light_blue_active_Checkbox: n60,
  light_blue_active_Switch: n60,
  light_blue_active_TooltipContent: n60,
  light_blue_active_RadioGroupItem: n60,
  light_blue_active_Input: n60,
  light_blue_active_TextArea: n60,
  light_purple_alt1: n61,
  light_purple_alt2: n62,
  light_purple_active: n63,
  light_purple_surface3: n63,
  light_purple_Button: n63,
  light_purple_SliderTrackActive: n63,
  light_purple_active_SliderTrackActive: n63,
  light_purple_surface1: n64,
  light_purple_ListItem: n64,
  light_purple_SelectTrigger: n64,
  light_purple_Card: n64,
  light_purple_Progress: n64,
  light_purple_TooltipArrow: n64,
  light_purple_SliderTrack: n64,
  light_purple_Input: n64,
  light_purple_TextArea: n64,
  light_purple_active_ListItem: n64,
  light_purple_active_Progress: n64,
  light_purple_active_TooltipArrow: n64,
  light_purple_active_SliderTrack: n64,
  light_purple_surface2: n65,
  light_purple_Checkbox: n65,
  light_purple_Switch: n65,
  light_purple_TooltipContent: n65,
  light_purple_RadioGroupItem: n65,
  light_purple_surface4: n66,
  light_purple_active_SelectTrigger: n66,
  light_purple_active_Card: n66,
  light_purple_active_Button: n66,
  light_purple_active_Checkbox: n66,
  light_purple_active_Switch: n66,
  light_purple_active_TooltipContent: n66,
  light_purple_active_RadioGroupItem: n66,
  light_purple_active_Input: n66,
  light_purple_active_TextArea: n66,
  light_pink_alt1: n67,
  light_pink_alt2: n68,
  light_pink_active: n69,
  light_pink_surface3: n69,
  light_pink_Button: n69,
  light_pink_SliderTrackActive: n69,
  light_pink_active_SliderTrackActive: n69,
  light_pink_surface1: n70,
  light_pink_ListItem: n70,
  light_pink_SelectTrigger: n70,
  light_pink_Card: n70,
  light_pink_Progress: n70,
  light_pink_TooltipArrow: n70,
  light_pink_SliderTrack: n70,
  light_pink_Input: n70,
  light_pink_TextArea: n70,
  light_pink_active_ListItem: n70,
  light_pink_active_Progress: n70,
  light_pink_active_TooltipArrow: n70,
  light_pink_active_SliderTrack: n70,
  light_pink_surface2: n71,
  light_pink_Checkbox: n71,
  light_pink_Switch: n71,
  light_pink_TooltipContent: n71,
  light_pink_RadioGroupItem: n71,
  light_pink_surface4: n72,
  light_pink_active_SelectTrigger: n72,
  light_pink_active_Card: n72,
  light_pink_active_Button: n72,
  light_pink_active_Checkbox: n72,
  light_pink_active_Switch: n72,
  light_pink_active_TooltipContent: n72,
  light_pink_active_RadioGroupItem: n72,
  light_pink_active_Input: n72,
  light_pink_active_TextArea: n72,
  light_red_alt1: n73,
  light_red_alt2: n74,
  light_red_active: n75,
  light_red_surface3: n75,
  light_red_Button: n75,
  light_red_SliderTrackActive: n75,
  light_red_active_SliderTrackActive: n75,
  light_red_surface1: n76,
  light_red_ListItem: n76,
  light_red_SelectTrigger: n76,
  light_red_Card: n76,
  light_red_Progress: n76,
  light_red_TooltipArrow: n76,
  light_red_SliderTrack: n76,
  light_red_Input: n76,
  light_red_TextArea: n76,
  light_red_active_ListItem: n76,
  light_red_active_Progress: n76,
  light_red_active_TooltipArrow: n76,
  light_red_active_SliderTrack: n76,
  light_red_surface2: n77,
  light_red_Checkbox: n77,
  light_red_Switch: n77,
  light_red_TooltipContent: n77,
  light_red_RadioGroupItem: n77,
  light_red_surface4: n78,
  light_red_active_SelectTrigger: n78,
  light_red_active_Card: n78,
  light_red_active_Button: n78,
  light_red_active_Checkbox: n78,
  light_red_active_Switch: n78,
  light_red_active_TooltipContent: n78,
  light_red_active_RadioGroupItem: n78,
  light_red_active_Input: n78,
  light_red_active_TextArea: n78,
  light_gray_alt1: n79,
  light_gray_alt2: n80,
  light_gray_active: n81,
  light_gray_surface3: n81,
  light_gray_Button: n81,
  light_gray_SliderTrackActive: n81,
  light_gray_active_SliderTrackActive: n81,
  light_gray_surface1: n82,
  light_gray_ListItem: n82,
  light_gray_SelectTrigger: n82,
  light_gray_Card: n82,
  light_gray_Progress: n82,
  light_gray_TooltipArrow: n82,
  light_gray_SliderTrack: n82,
  light_gray_Input: n82,
  light_gray_TextArea: n82,
  light_gray_active_ListItem: n82,
  light_gray_active_Progress: n82,
  light_gray_active_TooltipArrow: n82,
  light_gray_active_SliderTrack: n82,
  light_gray_surface2: n83,
  light_gray_Checkbox: n83,
  light_gray_Switch: n83,
  light_gray_TooltipContent: n83,
  light_gray_RadioGroupItem: n83,
  light_gray_surface4: n84,
  light_gray_active_SelectTrigger: n84,
  light_gray_active_Card: n84,
  light_gray_active_Button: n84,
  light_gray_active_Checkbox: n84,
  light_gray_active_Switch: n84,
  light_gray_active_TooltipContent: n84,
  light_gray_active_RadioGroupItem: n84,
  light_gray_active_Input: n84,
  light_gray_active_TextArea: n84,
  light_bronze_alt1: n85,
  light_bronze_alt2: n86,
  light_bronze_active: n87,
  light_bronze_surface3: n87,
  light_bronze_Button: n87,
  light_bronze_SliderTrackActive: n87,
  light_bronze_active_SliderTrackActive: n87,
  light_bronze_surface1: n88,
  light_bronze_ListItem: n88,
  light_bronze_SelectTrigger: n88,
  light_bronze_Card: n88,
  light_bronze_Progress: n88,
  light_bronze_TooltipArrow: n88,
  light_bronze_SliderTrack: n88,
  light_bronze_Input: n88,
  light_bronze_TextArea: n88,
  light_bronze_active_ListItem: n88,
  light_bronze_active_Progress: n88,
  light_bronze_active_TooltipArrow: n88,
  light_bronze_active_SliderTrack: n88,
  light_bronze_surface2: n89,
  light_bronze_Checkbox: n89,
  light_bronze_Switch: n89,
  light_bronze_TooltipContent: n89,
  light_bronze_RadioGroupItem: n89,
  light_bronze_surface4: n90,
  light_bronze_active_SelectTrigger: n90,
  light_bronze_active_Card: n90,
  light_bronze_active_Button: n90,
  light_bronze_active_Checkbox: n90,
  light_bronze_active_Switch: n90,
  light_bronze_active_TooltipContent: n90,
  light_bronze_active_RadioGroupItem: n90,
  light_bronze_active_Input: n90,
  light_bronze_active_TextArea: n90,
  light_gold_alt1: n91,
  light_gold_alt2: n92,
  light_gold_active: n93,
  light_gold_surface3: n93,
  light_gold_Button: n93,
  light_gold_SliderTrackActive: n93,
  light_gold_active_SliderTrackActive: n93,
  light_gold_surface1: n94,
  light_gold_ListItem: n94,
  light_gold_SelectTrigger: n94,
  light_gold_Card: n94,
  light_gold_Progress: n94,
  light_gold_TooltipArrow: n94,
  light_gold_SliderTrack: n94,
  light_gold_Input: n94,
  light_gold_TextArea: n94,
  light_gold_active_ListItem: n94,
  light_gold_active_Progress: n94,
  light_gold_active_TooltipArrow: n94,
  light_gold_active_SliderTrack: n94,
  light_gold_surface2: n95,
  light_gold_Checkbox: n95,
  light_gold_Switch: n95,
  light_gold_TooltipContent: n95,
  light_gold_RadioGroupItem: n95,
  light_gold_surface4: n96,
  light_gold_active_SelectTrigger: n96,
  light_gold_active_Card: n96,
  light_gold_active_Button: n96,
  light_gold_active_Checkbox: n96,
  light_gold_active_Switch: n96,
  light_gold_active_TooltipContent: n96,
  light_gold_active_RadioGroupItem: n96,
  light_gold_active_Input: n96,
  light_gold_active_TextArea: n96,
  light_orangeA_alt1: n97,
  light_orangeA_alt2: n98,
  light_orangeA_active: n99,
  light_orangeA_surface3: n99,
  light_orangeA_Button: n99,
  light_orangeA_SliderTrackActive: n99,
  light_orangeA_active_SliderTrackActive: n99,
  light_orangeA_surface1: n100,
  light_orangeA_ListItem: n100,
  light_orangeA_SelectTrigger: n100,
  light_orangeA_Card: n100,
  light_orangeA_Progress: n100,
  light_orangeA_TooltipArrow: n100,
  light_orangeA_SliderTrack: n100,
  light_orangeA_Input: n100,
  light_orangeA_TextArea: n100,
  light_orangeA_active_ListItem: n100,
  light_orangeA_active_Progress: n100,
  light_orangeA_active_TooltipArrow: n100,
  light_orangeA_active_SliderTrack: n100,
  light_orangeA_surface2: n101,
  light_orangeA_Checkbox: n101,
  light_orangeA_Switch: n101,
  light_orangeA_TooltipContent: n101,
  light_orangeA_RadioGroupItem: n101,
  light_orangeA_surface4: n102,
  light_orangeA_active_SelectTrigger: n102,
  light_orangeA_active_Card: n102,
  light_orangeA_active_Button: n102,
  light_orangeA_active_Checkbox: n102,
  light_orangeA_active_Switch: n102,
  light_orangeA_active_TooltipContent: n102,
  light_orangeA_active_RadioGroupItem: n102,
  light_orangeA_active_Input: n102,
  light_orangeA_active_TextArea: n102,
  dark_orange_alt1: n103,
  dark_orange_alt2: n104,
  dark_orange_active: n105,
  dark_orange_surface3: n105,
  dark_orange_Button: n105,
  dark_orange_SliderTrackActive: n105,
  dark_orange_active_SliderTrackActive: n105,
  dark_orange_surface1: n106,
  dark_orange_ListItem: n106,
  dark_orange_SelectTrigger: n106,
  dark_orange_Card: n106,
  dark_orange_Progress: n106,
  dark_orange_TooltipArrow: n106,
  dark_orange_SliderTrack: n106,
  dark_orange_Input: n106,
  dark_orange_TextArea: n106,
  dark_orange_active_ListItem: n106,
  dark_orange_active_Progress: n106,
  dark_orange_active_TooltipArrow: n106,
  dark_orange_active_SliderTrack: n106,
  dark_orange_surface2: n107,
  dark_orange_Checkbox: n107,
  dark_orange_Switch: n107,
  dark_orange_TooltipContent: n107,
  dark_orange_RadioGroupItem: n107,
  dark_orange_surface4: n108,
  dark_orange_active_SelectTrigger: n108,
  dark_orange_active_Card: n108,
  dark_orange_active_Button: n108,
  dark_orange_active_Checkbox: n108,
  dark_orange_active_Switch: n108,
  dark_orange_active_TooltipContent: n108,
  dark_orange_active_RadioGroupItem: n108,
  dark_orange_active_Input: n108,
  dark_orange_active_TextArea: n108,
  dark_yellow_alt1: n109,
  dark_yellow_alt2: n110,
  dark_yellow_active: n111,
  dark_yellow_surface3: n111,
  dark_yellow_Button: n111,
  dark_yellow_SliderTrackActive: n111,
  dark_yellow_active_SliderTrackActive: n111,
  dark_yellow_surface1: n112,
  dark_yellow_ListItem: n112,
  dark_yellow_SelectTrigger: n112,
  dark_yellow_Card: n112,
  dark_yellow_Progress: n112,
  dark_yellow_TooltipArrow: n112,
  dark_yellow_SliderTrack: n112,
  dark_yellow_Input: n112,
  dark_yellow_TextArea: n112,
  dark_yellow_active_ListItem: n112,
  dark_yellow_active_Progress: n112,
  dark_yellow_active_TooltipArrow: n112,
  dark_yellow_active_SliderTrack: n112,
  dark_yellow_surface2: n113,
  dark_yellow_Checkbox: n113,
  dark_yellow_Switch: n113,
  dark_yellow_TooltipContent: n113,
  dark_yellow_RadioGroupItem: n113,
  dark_yellow_surface4: n114,
  dark_yellow_active_SelectTrigger: n114,
  dark_yellow_active_Card: n114,
  dark_yellow_active_Button: n114,
  dark_yellow_active_Checkbox: n114,
  dark_yellow_active_Switch: n114,
  dark_yellow_active_TooltipContent: n114,
  dark_yellow_active_RadioGroupItem: n114,
  dark_yellow_active_Input: n114,
  dark_yellow_active_TextArea: n114,
  dark_green_alt1: n115,
  dark_green_alt2: n116,
  dark_green_active: n117,
  dark_green_surface3: n117,
  dark_green_Button: n117,
  dark_green_SliderTrackActive: n117,
  dark_green_active_SliderTrackActive: n117,
  dark_green_surface1: n118,
  dark_green_ListItem: n118,
  dark_green_SelectTrigger: n118,
  dark_green_Card: n118,
  dark_green_Progress: n118,
  dark_green_TooltipArrow: n118,
  dark_green_SliderTrack: n118,
  dark_green_Input: n118,
  dark_green_TextArea: n118,
  dark_green_active_ListItem: n118,
  dark_green_active_Progress: n118,
  dark_green_active_TooltipArrow: n118,
  dark_green_active_SliderTrack: n118,
  dark_green_surface2: n119,
  dark_green_Checkbox: n119,
  dark_green_Switch: n119,
  dark_green_TooltipContent: n119,
  dark_green_RadioGroupItem: n119,
  dark_green_surface4: n120,
  dark_green_active_SelectTrigger: n120,
  dark_green_active_Card: n120,
  dark_green_active_Button: n120,
  dark_green_active_Checkbox: n120,
  dark_green_active_Switch: n120,
  dark_green_active_TooltipContent: n120,
  dark_green_active_RadioGroupItem: n120,
  dark_green_active_Input: n120,
  dark_green_active_TextArea: n120,
  dark_blue_alt1: n121,
  dark_blue_alt2: n122,
  dark_blue_active: n123,
  dark_blue_surface3: n123,
  dark_blue_Button: n123,
  dark_blue_SliderTrackActive: n123,
  dark_blue_active_SliderTrackActive: n123,
  dark_blue_surface1: n124,
  dark_blue_ListItem: n124,
  dark_blue_SelectTrigger: n124,
  dark_blue_Card: n124,
  dark_blue_Progress: n124,
  dark_blue_TooltipArrow: n124,
  dark_blue_SliderTrack: n124,
  dark_blue_Input: n124,
  dark_blue_TextArea: n124,
  dark_blue_active_ListItem: n124,
  dark_blue_active_Progress: n124,
  dark_blue_active_TooltipArrow: n124,
  dark_blue_active_SliderTrack: n124,
  dark_blue_surface2: n125,
  dark_blue_Checkbox: n125,
  dark_blue_Switch: n125,
  dark_blue_TooltipContent: n125,
  dark_blue_RadioGroupItem: n125,
  dark_blue_surface4: n126,
  dark_blue_active_SelectTrigger: n126,
  dark_blue_active_Card: n126,
  dark_blue_active_Button: n126,
  dark_blue_active_Checkbox: n126,
  dark_blue_active_Switch: n126,
  dark_blue_active_TooltipContent: n126,
  dark_blue_active_RadioGroupItem: n126,
  dark_blue_active_Input: n126,
  dark_blue_active_TextArea: n126,
  dark_purple_alt1: n127,
  dark_purple_alt2: n128,
  dark_purple_active: n129,
  dark_purple_surface3: n129,
  dark_purple_Button: n129,
  dark_purple_SliderTrackActive: n129,
  dark_purple_active_SliderTrackActive: n129,
  dark_purple_surface1: n130,
  dark_purple_ListItem: n130,
  dark_purple_SelectTrigger: n130,
  dark_purple_Card: n130,
  dark_purple_Progress: n130,
  dark_purple_TooltipArrow: n130,
  dark_purple_SliderTrack: n130,
  dark_purple_Input: n130,
  dark_purple_TextArea: n130,
  dark_purple_active_ListItem: n130,
  dark_purple_active_Progress: n130,
  dark_purple_active_TooltipArrow: n130,
  dark_purple_active_SliderTrack: n130,
  dark_purple_surface2: n131,
  dark_purple_Checkbox: n131,
  dark_purple_Switch: n131,
  dark_purple_TooltipContent: n131,
  dark_purple_RadioGroupItem: n131,
  dark_purple_surface4: n132,
  dark_purple_active_SelectTrigger: n132,
  dark_purple_active_Card: n132,
  dark_purple_active_Button: n132,
  dark_purple_active_Checkbox: n132,
  dark_purple_active_Switch: n132,
  dark_purple_active_TooltipContent: n132,
  dark_purple_active_RadioGroupItem: n132,
  dark_purple_active_Input: n132,
  dark_purple_active_TextArea: n132,
  dark_pink_alt1: n133,
  dark_pink_alt2: n134,
  dark_pink_active: n135,
  dark_pink_surface3: n135,
  dark_pink_Button: n135,
  dark_pink_SliderTrackActive: n135,
  dark_pink_active_SliderTrackActive: n135,
  dark_pink_surface1: n136,
  dark_pink_ListItem: n136,
  dark_pink_SelectTrigger: n136,
  dark_pink_Card: n136,
  dark_pink_Progress: n136,
  dark_pink_TooltipArrow: n136,
  dark_pink_SliderTrack: n136,
  dark_pink_Input: n136,
  dark_pink_TextArea: n136,
  dark_pink_active_ListItem: n136,
  dark_pink_active_Progress: n136,
  dark_pink_active_TooltipArrow: n136,
  dark_pink_active_SliderTrack: n136,
  dark_pink_surface2: n137,
  dark_pink_Checkbox: n137,
  dark_pink_Switch: n137,
  dark_pink_TooltipContent: n137,
  dark_pink_RadioGroupItem: n137,
  dark_pink_surface4: n138,
  dark_pink_active_SelectTrigger: n138,
  dark_pink_active_Card: n138,
  dark_pink_active_Button: n138,
  dark_pink_active_Checkbox: n138,
  dark_pink_active_Switch: n138,
  dark_pink_active_TooltipContent: n138,
  dark_pink_active_RadioGroupItem: n138,
  dark_pink_active_Input: n138,
  dark_pink_active_TextArea: n138,
  dark_red_alt1: n139,
  dark_red_alt2: n140,
  dark_red_active: n141,
  dark_red_surface3: n141,
  dark_red_Button: n141,
  dark_red_SliderTrackActive: n141,
  dark_red_active_SliderTrackActive: n141,
  dark_red_surface1: n142,
  dark_red_ListItem: n142,
  dark_red_SelectTrigger: n142,
  dark_red_Card: n142,
  dark_red_Progress: n142,
  dark_red_TooltipArrow: n142,
  dark_red_SliderTrack: n142,
  dark_red_Input: n142,
  dark_red_TextArea: n142,
  dark_red_active_ListItem: n142,
  dark_red_active_Progress: n142,
  dark_red_active_TooltipArrow: n142,
  dark_red_active_SliderTrack: n142,
  dark_red_surface2: n143,
  dark_red_Checkbox: n143,
  dark_red_Switch: n143,
  dark_red_TooltipContent: n143,
  dark_red_RadioGroupItem: n143,
  dark_red_surface4: n144,
  dark_red_active_SelectTrigger: n144,
  dark_red_active_Card: n144,
  dark_red_active_Button: n144,
  dark_red_active_Checkbox: n144,
  dark_red_active_Switch: n144,
  dark_red_active_TooltipContent: n144,
  dark_red_active_RadioGroupItem: n144,
  dark_red_active_Input: n144,
  dark_red_active_TextArea: n144,
  dark_gray_alt1: n145,
  dark_gray_alt2: n146,
  dark_gray_active: n147,
  dark_gray_surface3: n147,
  dark_gray_Button: n147,
  dark_gray_SliderTrackActive: n147,
  dark_gray_active_SliderTrackActive: n147,
  dark_gray_surface1: n148,
  dark_gray_ListItem: n148,
  dark_gray_SelectTrigger: n148,
  dark_gray_Card: n148,
  dark_gray_Progress: n148,
  dark_gray_TooltipArrow: n148,
  dark_gray_SliderTrack: n148,
  dark_gray_Input: n148,
  dark_gray_TextArea: n148,
  dark_gray_active_ListItem: n148,
  dark_gray_active_Progress: n148,
  dark_gray_active_TooltipArrow: n148,
  dark_gray_active_SliderTrack: n148,
  dark_gray_surface2: n149,
  dark_gray_Checkbox: n149,
  dark_gray_Switch: n149,
  dark_gray_TooltipContent: n149,
  dark_gray_RadioGroupItem: n149,
  dark_gray_surface4: n150,
  dark_gray_active_SelectTrigger: n150,
  dark_gray_active_Card: n150,
  dark_gray_active_Button: n150,
  dark_gray_active_Checkbox: n150,
  dark_gray_active_Switch: n150,
  dark_gray_active_TooltipContent: n150,
  dark_gray_active_RadioGroupItem: n150,
  dark_gray_active_Input: n150,
  dark_gray_active_TextArea: n150,
  dark_bronze_alt1: n151,
  dark_bronze_alt2: n152,
  dark_bronze_active: n153,
  dark_bronze_surface3: n153,
  dark_bronze_Button: n153,
  dark_bronze_SliderTrackActive: n153,
  dark_bronze_active_SliderTrackActive: n153,
  dark_bronze_surface1: n154,
  dark_bronze_ListItem: n154,
  dark_bronze_SelectTrigger: n154,
  dark_bronze_Card: n154,
  dark_bronze_Progress: n154,
  dark_bronze_TooltipArrow: n154,
  dark_bronze_SliderTrack: n154,
  dark_bronze_Input: n154,
  dark_bronze_TextArea: n154,
  dark_bronze_active_ListItem: n154,
  dark_bronze_active_Progress: n154,
  dark_bronze_active_TooltipArrow: n154,
  dark_bronze_active_SliderTrack: n154,
  dark_bronze_surface2: n155,
  dark_bronze_Checkbox: n155,
  dark_bronze_Switch: n155,
  dark_bronze_TooltipContent: n155,
  dark_bronze_RadioGroupItem: n155,
  dark_bronze_surface4: n156,
  dark_bronze_active_SelectTrigger: n156,
  dark_bronze_active_Card: n156,
  dark_bronze_active_Button: n156,
  dark_bronze_active_Checkbox: n156,
  dark_bronze_active_Switch: n156,
  dark_bronze_active_TooltipContent: n156,
  dark_bronze_active_RadioGroupItem: n156,
  dark_bronze_active_Input: n156,
  dark_bronze_active_TextArea: n156,
  dark_gold_alt1: n157,
  dark_gold_alt2: n158,
  dark_gold_active: n159,
  dark_gold_surface3: n159,
  dark_gold_Button: n159,
  dark_gold_SliderTrackActive: n159,
  dark_gold_active_SliderTrackActive: n159,
  dark_gold_surface1: n160,
  dark_gold_ListItem: n160,
  dark_gold_SelectTrigger: n160,
  dark_gold_Card: n160,
  dark_gold_Progress: n160,
  dark_gold_TooltipArrow: n160,
  dark_gold_SliderTrack: n160,
  dark_gold_Input: n160,
  dark_gold_TextArea: n160,
  dark_gold_active_ListItem: n160,
  dark_gold_active_Progress: n160,
  dark_gold_active_TooltipArrow: n160,
  dark_gold_active_SliderTrack: n160,
  dark_gold_surface2: n161,
  dark_gold_Checkbox: n161,
  dark_gold_Switch: n161,
  dark_gold_TooltipContent: n161,
  dark_gold_RadioGroupItem: n161,
  dark_gold_surface4: n162,
  dark_gold_active_SelectTrigger: n162,
  dark_gold_active_Card: n162,
  dark_gold_active_Button: n162,
  dark_gold_active_Checkbox: n162,
  dark_gold_active_Switch: n162,
  dark_gold_active_TooltipContent: n162,
  dark_gold_active_RadioGroupItem: n162,
  dark_gold_active_Input: n162,
  dark_gold_active_TextArea: n162,
  dark_orangeA_alt1: n163,
  dark_orangeA_alt2: n164,
  dark_orangeA_active: n165,
  dark_orangeA_surface3: n165,
  dark_orangeA_Button: n165,
  dark_orangeA_SliderTrackActive: n165,
  dark_orangeA_active_SliderTrackActive: n165,
  dark_orangeA_surface1: n166,
  dark_orangeA_ListItem: n166,
  dark_orangeA_SelectTrigger: n166,
  dark_orangeA_Card: n166,
  dark_orangeA_Progress: n166,
  dark_orangeA_TooltipArrow: n166,
  dark_orangeA_SliderTrack: n166,
  dark_orangeA_Input: n166,
  dark_orangeA_TextArea: n166,
  dark_orangeA_active_ListItem: n166,
  dark_orangeA_active_Progress: n166,
  dark_orangeA_active_TooltipArrow: n166,
  dark_orangeA_active_SliderTrack: n166,
  dark_orangeA_surface2: n167,
  dark_orangeA_Checkbox: n167,
  dark_orangeA_Switch: n167,
  dark_orangeA_TooltipContent: n167,
  dark_orangeA_RadioGroupItem: n167,
  dark_orangeA_surface4: n168,
  dark_orangeA_active_SelectTrigger: n168,
  dark_orangeA_active_Card: n168,
  dark_orangeA_active_Button: n168,
  dark_orangeA_active_Checkbox: n168,
  dark_orangeA_active_Switch: n168,
  dark_orangeA_active_TooltipContent: n168,
  dark_orangeA_active_RadioGroupItem: n168,
  dark_orangeA_active_Input: n168,
  dark_orangeA_active_TextArea: n168,
  light_SwitchThumb: n169,
  light_SliderThumb: n169,
  light_Tooltip: n169,
  light_ProgressIndicator: n169,
  light_SheetOverlay: n170,
  light_DialogOverlay: n170,
  light_ModalOverlay: n170,
  light_orange_SheetOverlay: n170,
  light_orange_DialogOverlay: n170,
  light_orange_ModalOverlay: n170,
  light_yellow_SheetOverlay: n170,
  light_yellow_DialogOverlay: n170,
  light_yellow_ModalOverlay: n170,
  light_green_SheetOverlay: n170,
  light_green_DialogOverlay: n170,
  light_green_ModalOverlay: n170,
  light_blue_SheetOverlay: n170,
  light_blue_DialogOverlay: n170,
  light_blue_ModalOverlay: n170,
  light_purple_SheetOverlay: n170,
  light_purple_DialogOverlay: n170,
  light_purple_ModalOverlay: n170,
  light_pink_SheetOverlay: n170,
  light_pink_DialogOverlay: n170,
  light_pink_ModalOverlay: n170,
  light_red_SheetOverlay: n170,
  light_red_DialogOverlay: n170,
  light_red_ModalOverlay: n170,
  light_gray_SheetOverlay: n170,
  light_gray_DialogOverlay: n170,
  light_gray_ModalOverlay: n170,
  light_bronze_SheetOverlay: n170,
  light_bronze_DialogOverlay: n170,
  light_bronze_ModalOverlay: n170,
  light_gold_SheetOverlay: n170,
  light_gold_DialogOverlay: n170,
  light_gold_ModalOverlay: n170,
  light_orangeA_SheetOverlay: n170,
  light_orangeA_DialogOverlay: n170,
  light_orangeA_ModalOverlay: n170,
  light_active_SheetOverlay: n170,
  light_active_DialogOverlay: n170,
  light_active_ModalOverlay: n170,
  light_orange_active_SheetOverlay: n170,
  light_orange_active_DialogOverlay: n170,
  light_orange_active_ModalOverlay: n170,
  light_yellow_active_SheetOverlay: n170,
  light_yellow_active_DialogOverlay: n170,
  light_yellow_active_ModalOverlay: n170,
  light_green_active_SheetOverlay: n170,
  light_green_active_DialogOverlay: n170,
  light_green_active_ModalOverlay: n170,
  light_blue_active_SheetOverlay: n170,
  light_blue_active_DialogOverlay: n170,
  light_blue_active_ModalOverlay: n170,
  light_purple_active_SheetOverlay: n170,
  light_purple_active_DialogOverlay: n170,
  light_purple_active_ModalOverlay: n170,
  light_pink_active_SheetOverlay: n170,
  light_pink_active_DialogOverlay: n170,
  light_pink_active_ModalOverlay: n170,
  light_red_active_SheetOverlay: n170,
  light_red_active_DialogOverlay: n170,
  light_red_active_ModalOverlay: n170,
  light_gray_active_SheetOverlay: n170,
  light_gray_active_DialogOverlay: n170,
  light_gray_active_ModalOverlay: n170,
  light_bronze_active_SheetOverlay: n170,
  light_bronze_active_DialogOverlay: n170,
  light_bronze_active_ModalOverlay: n170,
  light_gold_active_SheetOverlay: n170,
  light_gold_active_DialogOverlay: n170,
  light_gold_active_ModalOverlay: n170,
  light_orangeA_active_SheetOverlay: n170,
  light_orangeA_active_DialogOverlay: n170,
  light_orangeA_active_ModalOverlay: n170,
  dark_SwitchThumb: n171,
  dark_SliderThumb: n171,
  dark_Tooltip: n171,
  dark_ProgressIndicator: n171,
  dark_SheetOverlay: n172,
  dark_DialogOverlay: n172,
  dark_ModalOverlay: n172,
  dark_orange_SheetOverlay: n172,
  dark_orange_DialogOverlay: n172,
  dark_orange_ModalOverlay: n172,
  dark_yellow_SheetOverlay: n172,
  dark_yellow_DialogOverlay: n172,
  dark_yellow_ModalOverlay: n172,
  dark_green_SheetOverlay: n172,
  dark_green_DialogOverlay: n172,
  dark_green_ModalOverlay: n172,
  dark_blue_SheetOverlay: n172,
  dark_blue_DialogOverlay: n172,
  dark_blue_ModalOverlay: n172,
  dark_purple_SheetOverlay: n172,
  dark_purple_DialogOverlay: n172,
  dark_purple_ModalOverlay: n172,
  dark_pink_SheetOverlay: n172,
  dark_pink_DialogOverlay: n172,
  dark_pink_ModalOverlay: n172,
  dark_red_SheetOverlay: n172,
  dark_red_DialogOverlay: n172,
  dark_red_ModalOverlay: n172,
  dark_gray_SheetOverlay: n172,
  dark_gray_DialogOverlay: n172,
  dark_gray_ModalOverlay: n172,
  dark_bronze_SheetOverlay: n172,
  dark_bronze_DialogOverlay: n172,
  dark_bronze_ModalOverlay: n172,
  dark_gold_SheetOverlay: n172,
  dark_gold_DialogOverlay: n172,
  dark_gold_ModalOverlay: n172,
  dark_orangeA_SheetOverlay: n172,
  dark_orangeA_DialogOverlay: n172,
  dark_orangeA_ModalOverlay: n172,
  dark_active_SheetOverlay: n172,
  dark_active_DialogOverlay: n172,
  dark_active_ModalOverlay: n172,
  dark_orange_active_SheetOverlay: n172,
  dark_orange_active_DialogOverlay: n172,
  dark_orange_active_ModalOverlay: n172,
  dark_yellow_active_SheetOverlay: n172,
  dark_yellow_active_DialogOverlay: n172,
  dark_yellow_active_ModalOverlay: n172,
  dark_green_active_SheetOverlay: n172,
  dark_green_active_DialogOverlay: n172,
  dark_green_active_ModalOverlay: n172,
  dark_blue_active_SheetOverlay: n172,
  dark_blue_active_DialogOverlay: n172,
  dark_blue_active_ModalOverlay: n172,
  dark_purple_active_SheetOverlay: n172,
  dark_purple_active_DialogOverlay: n172,
  dark_purple_active_ModalOverlay: n172,
  dark_pink_active_SheetOverlay: n172,
  dark_pink_active_DialogOverlay: n172,
  dark_pink_active_ModalOverlay: n172,
  dark_red_active_SheetOverlay: n172,
  dark_red_active_DialogOverlay: n172,
  dark_red_active_ModalOverlay: n172,
  dark_gray_active_SheetOverlay: n172,
  dark_gray_active_DialogOverlay: n172,
  dark_gray_active_ModalOverlay: n172,
  dark_bronze_active_SheetOverlay: n172,
  dark_bronze_active_DialogOverlay: n172,
  dark_bronze_active_ModalOverlay: n172,
  dark_gold_active_SheetOverlay: n172,
  dark_gold_active_DialogOverlay: n172,
  dark_gold_active_ModalOverlay: n172,
  dark_orangeA_active_SheetOverlay: n172,
  dark_orangeA_active_DialogOverlay: n172,
  dark_orangeA_active_ModalOverlay: n172,
  light_orange_SwitchThumb: n173,
  light_orange_SliderThumb: n173,
  light_orange_Tooltip: n173,
  light_orange_ProgressIndicator: n173,
  light_yellow_SwitchThumb: n174,
  light_yellow_SliderThumb: n174,
  light_yellow_Tooltip: n174,
  light_yellow_ProgressIndicator: n174,
  light_green_SwitchThumb: n175,
  light_green_SliderThumb: n175,
  light_green_Tooltip: n175,
  light_green_ProgressIndicator: n175,
  light_blue_SwitchThumb: n176,
  light_blue_SliderThumb: n176,
  light_blue_Tooltip: n176,
  light_blue_ProgressIndicator: n176,
  light_purple_SwitchThumb: n177,
  light_purple_SliderThumb: n177,
  light_purple_Tooltip: n177,
  light_purple_ProgressIndicator: n177,
  light_pink_SwitchThumb: n178,
  light_pink_SliderThumb: n178,
  light_pink_Tooltip: n178,
  light_pink_ProgressIndicator: n178,
  light_red_SwitchThumb: n179,
  light_red_SliderThumb: n179,
  light_red_Tooltip: n179,
  light_red_ProgressIndicator: n179,
  light_gray_SwitchThumb: n180,
  light_gray_SliderThumb: n180,
  light_gray_Tooltip: n180,
  light_gray_ProgressIndicator: n180,
  light_bronze_SwitchThumb: n181,
  light_bronze_SliderThumb: n181,
  light_bronze_Tooltip: n181,
  light_bronze_ProgressIndicator: n181,
  light_gold_SwitchThumb: n182,
  light_gold_SliderThumb: n182,
  light_gold_Tooltip: n182,
  light_gold_ProgressIndicator: n182,
  light_orangeA_SwitchThumb: n183,
  light_orangeA_SliderThumb: n183,
  light_orangeA_Tooltip: n183,
  light_orangeA_ProgressIndicator: n183,
  dark_orange_SwitchThumb: n184,
  dark_orange_SliderThumb: n184,
  dark_orange_Tooltip: n184,
  dark_orange_ProgressIndicator: n184,
  dark_yellow_SwitchThumb: n185,
  dark_yellow_SliderThumb: n185,
  dark_yellow_Tooltip: n185,
  dark_yellow_ProgressIndicator: n185,
  dark_green_SwitchThumb: n186,
  dark_green_SliderThumb: n186,
  dark_green_Tooltip: n186,
  dark_green_ProgressIndicator: n186,
  dark_blue_SwitchThumb: n187,
  dark_blue_SliderThumb: n187,
  dark_blue_Tooltip: n187,
  dark_blue_ProgressIndicator: n187,
  dark_purple_SwitchThumb: n188,
  dark_purple_SliderThumb: n188,
  dark_purple_Tooltip: n188,
  dark_purple_ProgressIndicator: n188,
  dark_pink_SwitchThumb: n189,
  dark_pink_SliderThumb: n189,
  dark_pink_Tooltip: n189,
  dark_pink_ProgressIndicator: n189,
  dark_red_SwitchThumb: n190,
  dark_red_SliderThumb: n190,
  dark_red_Tooltip: n190,
  dark_red_ProgressIndicator: n190,
  dark_gray_SwitchThumb: n191,
  dark_gray_SliderThumb: n191,
  dark_gray_Tooltip: n191,
  dark_gray_ProgressIndicator: n191,
  dark_bronze_SwitchThumb: n192,
  dark_bronze_SliderThumb: n192,
  dark_bronze_Tooltip: n192,
  dark_bronze_ProgressIndicator: n192,
  dark_gold_SwitchThumb: n193,
  dark_gold_SliderThumb: n193,
  dark_gold_Tooltip: n193,
  dark_gold_ProgressIndicator: n193,
  dark_orangeA_SwitchThumb: n194,
  dark_orangeA_SliderThumb: n194,
  dark_orangeA_Tooltip: n194,
  dark_orangeA_ProgressIndicator: n194,
  light_active_SwitchThumb: n195,
  light_active_SliderThumb: n195,
  light_active_Tooltip: n195,
  light_active_ProgressIndicator: n195,
  dark_active_SwitchThumb: n196,
  dark_active_SliderThumb: n196,
  dark_active_Tooltip: n196,
  dark_active_ProgressIndicator: n196,
  light_orange_active_SwitchThumb: n197,
  light_orange_active_SliderThumb: n197,
  light_orange_active_Tooltip: n197,
  light_orange_active_ProgressIndicator: n197,
  light_yellow_active_SwitchThumb: n198,
  light_yellow_active_SliderThumb: n198,
  light_yellow_active_Tooltip: n198,
  light_yellow_active_ProgressIndicator: n198,
  light_green_active_SwitchThumb: n199,
  light_green_active_SliderThumb: n199,
  light_green_active_Tooltip: n199,
  light_green_active_ProgressIndicator: n199,
  light_blue_active_SwitchThumb: n200,
  light_blue_active_SliderThumb: n200,
  light_blue_active_Tooltip: n200,
  light_blue_active_ProgressIndicator: n200,
  light_purple_active_SwitchThumb: n201,
  light_purple_active_SliderThumb: n201,
  light_purple_active_Tooltip: n201,
  light_purple_active_ProgressIndicator: n201,
  light_pink_active_SwitchThumb: n202,
  light_pink_active_SliderThumb: n202,
  light_pink_active_Tooltip: n202,
  light_pink_active_ProgressIndicator: n202,
  light_red_active_SwitchThumb: n203,
  light_red_active_SliderThumb: n203,
  light_red_active_Tooltip: n203,
  light_red_active_ProgressIndicator: n203,
  light_gray_active_SwitchThumb: n204,
  light_gray_active_SliderThumb: n204,
  light_gray_active_Tooltip: n204,
  light_gray_active_ProgressIndicator: n204,
  light_bronze_active_SwitchThumb: n205,
  light_bronze_active_SliderThumb: n205,
  light_bronze_active_Tooltip: n205,
  light_bronze_active_ProgressIndicator: n205,
  light_gold_active_SwitchThumb: n206,
  light_gold_active_SliderThumb: n206,
  light_gold_active_Tooltip: n206,
  light_gold_active_ProgressIndicator: n206,
  light_orangeA_active_SwitchThumb: n207,
  light_orangeA_active_SliderThumb: n207,
  light_orangeA_active_Tooltip: n207,
  light_orangeA_active_ProgressIndicator: n207,
  dark_orange_active_SwitchThumb: n208,
  dark_orange_active_SliderThumb: n208,
  dark_orange_active_Tooltip: n208,
  dark_orange_active_ProgressIndicator: n208,
  dark_yellow_active_SwitchThumb: n209,
  dark_yellow_active_SliderThumb: n209,
  dark_yellow_active_Tooltip: n209,
  dark_yellow_active_ProgressIndicator: n209,
  dark_green_active_SwitchThumb: n210,
  dark_green_active_SliderThumb: n210,
  dark_green_active_Tooltip: n210,
  dark_green_active_ProgressIndicator: n210,
  dark_blue_active_SwitchThumb: n211,
  dark_blue_active_SliderThumb: n211,
  dark_blue_active_Tooltip: n211,
  dark_blue_active_ProgressIndicator: n211,
  dark_purple_active_SwitchThumb: n212,
  dark_purple_active_SliderThumb: n212,
  dark_purple_active_Tooltip: n212,
  dark_purple_active_ProgressIndicator: n212,
  dark_pink_active_SwitchThumb: n213,
  dark_pink_active_SliderThumb: n213,
  dark_pink_active_Tooltip: n213,
  dark_pink_active_ProgressIndicator: n213,
  dark_red_active_SwitchThumb: n214,
  dark_red_active_SliderThumb: n214,
  dark_red_active_Tooltip: n214,
  dark_red_active_ProgressIndicator: n214,
  dark_gray_active_SwitchThumb: n215,
  dark_gray_active_SliderThumb: n215,
  dark_gray_active_Tooltip: n215,
  dark_gray_active_ProgressIndicator: n215,
  dark_bronze_active_SwitchThumb: n216,
  dark_bronze_active_SliderThumb: n216,
  dark_bronze_active_Tooltip: n216,
  dark_bronze_active_ProgressIndicator: n216,
  dark_gold_active_SwitchThumb: n217,
  dark_gold_active_SliderThumb: n217,
  dark_gold_active_Tooltip: n217,
  dark_gold_active_ProgressIndicator: n217,
  dark_orangeA_active_SwitchThumb: n218,
  dark_orangeA_active_SliderThumb: n218,
  dark_orangeA_active_Tooltip: n218,
  dark_orangeA_active_ProgressIndicator: n218,
}
